import { LocalizedStringsMethods } from "localized-strings";
import { UAParser } from "ua-parser-js";

let baseUrl: string = "localhost:8000";
let strings: (LocalizedStringsMethods & any) | null = null;

export function setUrl(url: string): void {
    baseUrl = url;
}

export function setStrings(newStrings: (LocalizedStringsMethods & {}) | null): void {
    strings = newStrings;
}
export interface LatLng {
    lat: number;
    lng: number;
}

export interface Image {
    thumb: SimpleImage;
    width: number;
    height: number;
    url: string;
}

export interface SimpleImage {
    width: number;
    height: number;
    url: string;
}

export interface File {
    name: string;
    url: string;
}

export interface Address {
    cep: string;
    number: string;
    street: string;
    neighborhood: string;
    city: string;
    cityId: string | null;
    state: string;
    uf: StateUF;
    latLng: LatLng;
}

export interface City {
    id: string;
    name: string;
    state: string;
    uf: string;
}

export interface Crop {
    x: number;
    y: number;
    width: number;
    height: number;
}

export interface UncertainImage {
    bytes: Buffer | null;
    image: Image | null;
    crop: Crop | null;
}

export interface UncertainFile {
    fileData: UploadFile | null;
    file: File | null;
}

export interface UploadFile {
    bytes: Buffer;
    name: string;
}

export interface Hotel {
    id: string;
    languages: HotelLanguage[];
    colors: HotelColors;
    logos: HotelLogos;
    videoUrl: string;
    email: string;
    phone: string;
    socialMedia: HotelDetailsSocialMedia;
    address: Address;
    reserveDisponibility: HotelDetailsReserveDisponibility;
    omnibeesId: string;
    metaTags: string[];
}

export interface HotelTranslation {
    nick: string;
    name: string;
    slogan: string | null;
    description: string;
    roomsDescription: string | null;
}

export interface HotelTranslatableDetails {
    image: UncertainImage;
    logos: HotelUncertainLogos;
    nick: string;
    name: string;
    slogan: string | null;
    description: string;
    roomsDescription: string | null;
}

export interface HotelDetails {
    colors: HotelColors;
    logos: HotelLogos;
    videoUrl: string;
    email: string;
    phone: string;
    socialMedia: HotelDetailsSocialMedia;
    address: Address;
    reserveDisponibility: HotelDetailsReserveDisponibility;
    omnibeesId: string;
    metaTags: string[];
}

export interface HotelDetailsSocialMedia {
    instagram: string | null;
    facebook: string | null;
    linkedin: string | null;
}

export interface HotelDetailsReserveDisponibility {
    start: number;
    end: number;
}

export interface HotelColors {
    primary: string;
    secondary: string;
    tertiary: string | null;
    background: string;
    textPrimary: string;
    textSecondary: string | null;
    textTertiary: string | null;
}

export interface HotelLogos {
    horizontal: Image;
    squared: Image;
    white: Image | null;
}

export interface HotelUncertainLogos {
    horizontal: UncertainImage;
    squared: UncertainImage;
    white: UncertainImage | null;
}

export interface HotelLanguage {
    language: Language;
    translation: HotelLanguageTranslation;
}

export interface HotelLanguageTranslation {
    image: Image;
    nick: string;
    name: string;
    slogan: string | null;
    description: string;
    roomsDescription: string | null;
}

export interface HotelInfo {
    id: string;
    image: Image;
    logos: HotelLogos;
    nick: string;
    name: string;
    slogan: string | null;
    description: string;
    roomsDescription: string | null;
    colors: HotelColors;
    videoUrl: string;
    email: string;
    phone: string;
    socialMedia: HotelDetailsSocialMedia;
    address: Address;
    reserveDisponibility: HotelDetailsReserveDisponibility;
    omnibeesId: string;
    metaTags: string[];
}

export interface AdminUser {
    id: string;
    hotel: Hotel;
    name: string;
    email: string;
}

export interface AdminUserDetails {
    name: string;
    email: string;
}

export interface Banner {
    id: string;
    languages: BannerLanguage[];
}

export interface BannerTranslation {
    nick: string;
    title: string;
    description: string | null;
    url: string | null;
}

export interface BannerTranslatableDetails {
    image: UncertainImage;
    mobileImage: UncertainImage | null;
    nick: string;
    title: string;
    description: string | null;
    url: string | null;
}

export interface BannerLanguage {
    language: Language;
    translation: BannerLanguageTranslation;
}

export interface BannerLanguageTranslation {
    image: Image;
    mobileImage: Image | null;
    nick: string;
    title: string;
    description: string | null;
    url: string | null;
}

export interface BannerInfo {
    id: string;
    image: Image;
    nick: string;
    title: string;
    description: string | null;
    url: string | null;
}

export interface NewBanner {
    image: UncertainImage;
    mobileImage: UncertainImage | null;
    nick: string;
    title: string;
    description: string | null;
    url: string | null;
}

export interface EditBanner {
    language: Language;
    image: UncertainImage;
    mobileImage: UncertainImage | null;
    nick: string;
    title: string;
    description: string | null;
    url: string | null;
}

export interface Bedroom {
    id: string;
    languages: BedroomLanguage[];
    bedroomSpecifications: BedroomSpecification[] | null;
    order: number | null;
}

export interface BedroomDetails {
    bedroomSpecifications: BedroomSpecification[] | null;
    order: number | null;
}

export interface BedroomSpecification {
    type: BedroomConfort;
    details: string;
}

export interface BedroomTranslation {
    nick: string;
    name: string;
    description: string | null;
    url: string | null;
}

export interface BedroomTranslatableDetails {
    images: UncertainImage[];
    nick: string;
    name: string;
    description: string | null;
    url: string | null;
}

export interface BedroomLanguage {
    language: Language;
    translation: BedroomLanguageTranslation;
}

export interface BedroomLanguageTranslation {
    images: Image[];
    nick: string;
    name: string;
    description: string | null;
    url: string | null;
}

export interface BedroomInfo {
    id: string;
    images: Image[];
    bedroomSpecifications: BedroomSpecification[] | null;
    order: number | null;
    nick: string;
    name: string;
    description: string | null;
    url: string | null;
}

export interface NewBedroom {
    bedroomSpecifications: BedroomSpecification[] | null;
    order: number | null;
    images: UncertainImage[];
    nick: string;
    name: string;
    description: string | null;
    url: string | null;
}

export interface EditBedroom {
    language: Language;
    bedroomSpecifications: BedroomSpecification[] | null;
    order: number | null;
    images: UncertainImage[];
    nick: string;
    name: string;
    description: string | null;
    url: string | null;
}

export interface BedroomChangeOrder {
    targetOrderBedroom: Bedroom;
    changedBedroom: Bedroom;
}

export interface NewContact {
    name: string;
    email: string;
    phone: string;
    city: string;
    subject: string | null;
    message: string;
}

export interface NewBudgetRequest {
    groupName: string;
    eventType: EventType;
    roomFormat: RoomFormat;
    date: Date | null;
    numberOfParticipants: number;
    name: string;
    company: string | null;
    phone: string;
    email: string;
    message: string | null;
}

export interface Gallery {
    id: string;
    languages: GalleryLanguage[];
}

export interface GalleryTranslation {
    nick: string;
    title: string;
    description: string | null;
}

export interface GalleryTranslatableDetails {
    image: UncertainImage;
    nick: string;
    title: string;
    description: string | null;
}

export interface GalleryLanguage {
    language: Language;
    translation: GalleryLanguageTranslation;
}

export interface GalleryLanguageTranslation {
    image: Image;
    nick: string;
    title: string;
    description: string | null;
}

export interface GalleryInfo {
    id: string;
    image: Image;
    nick: string;
    title: string;
    description: string | null;
}

export interface NewGallery {
    image: UncertainImage;
    nick: string;
    title: string;
    description: string | null;
}

export interface EditGallery {
    language: Language;
    image: UncertainImage;
    nick: string;
    title: string;
    description: string | null;
}

export interface GastroPlace {
    id: string;
    languages: GastroPlaceLanguage[];
}

export interface GastroPlaceTranslation {
    nick: string;
    name: string;
    description: string;
    url: string | null;
    type: GastroPlaceType;
}

export interface GastroPlaceTranslatableDetails {
    images: UncertainImage[];
    nick: string;
    name: string;
    description: string;
    url: string | null;
    type: GastroPlaceType;
}

export interface GastroPlaceLanguage {
    language: Language;
    translation: GastroPlaceLanguageTranslation;
}

export interface GastroPlaceLanguageTranslation {
    images: Image[];
    nick: string;
    name: string;
    description: string;
    url: string | null;
    type: GastroPlaceType;
}

export interface GastroPlaceInfo {
    id: string;
    images: Image[];
    nick: string;
    name: string;
    description: string;
    url: string | null;
    type: GastroPlaceType;
}

export interface NewGastroPlace {
    images: UncertainImage[];
    nick: string;
    name: string;
    description: string;
    url: string | null;
    type: GastroPlaceType;
}

export interface EditGastroPlace {
    language: Language;
    images: UncertainImage[];
    nick: string;
    name: string;
    description: string;
    url: string | null;
    type: GastroPlaceType;
}

export interface EditHotel {
    language: Language;
    image: UncertainImage;
    logos: HotelUncertainLogos;
    nick: string;
    name: string;
    slogan: string | null;
    description: string;
    roomsDescription: string | null;
    colors: HotelColors;
    videoUrl: string;
    email: string;
    phone: string;
    socialMedia: HotelDetailsSocialMedia;
    address: Address;
    reserveDisponibility: HotelDetailsReserveDisponibility;
    omnibeesId: string;
    metaTags: string[];
}

export interface Offer {
    id: string;
    languages: OfferLanguage[];
}

export interface OfferTranslation {
    nick: string;
    name: string;
    description: string | null;
    descriptionHtml: string | null;
    url: string | null;
}

export interface OfferTranslatableDetails {
    image: UncertainImage;
    nick: string;
    name: string;
    description: string | null;
    descriptionHtml: string | null;
    url: string | null;
}

export interface OfferLanguage {
    language: Language;
    translation: OfferLanguageTranslation;
}

export interface OfferLanguageTranslation {
    image: Image;
    nick: string;
    name: string;
    description: string | null;
    descriptionHtml: string | null;
    url: string | null;
}

export interface OfferInfo {
    id: string;
    image: Image;
    nick: string;
    name: string;
    description: string | null;
    descriptionHtml: string | null;
    url: string | null;
}

export interface NewOffer {
    image: UncertainImage;
    nick: string;
    name: string;
    description: string | null;
    descriptionHtml: string | null;
    url: string | null;
}

export interface EditOffer {
    language: Language;
    image: UncertainImage;
    nick: string;
    name: string;
    description: string | null;
    descriptionHtml: string | null;
    url: string | null;
}

export interface Room {
    id: string;
    languages: RoomLanguage[];
    order: number | null;
}

export interface RoomTranslation {
    name: string;
    nick: string;
    description: string | null;
    url: string | null;
}

export interface RoomTranslatableDetails {
    layouts: UncertainImage[];
    images: UncertainImage[];
    name: string;
    nick: string;
    description: string | null;
    url: string | null;
}

export interface RoomDetails {
    order: number | null;
}

export interface RoomLanguage {
    language: Language;
    translation: RoomLanguageTranslation;
}

export interface RoomLanguageTranslation {
    layouts: Image[];
    images: Image[];
    name: string;
    nick: string;
    description: string | null;
    url: string | null;
}

export interface RoomInfo {
    id: string;
    layouts: Image[];
    images: Image[];
    order: number | null;
    name: string;
    nick: string;
    description: string | null;
    url: string | null;
}

export interface NewRoom {
    order: number | null;
    layouts: UncertainImage[];
    images: UncertainImage[];
    name: string;
    nick: string;
    description: string | null;
    url: string | null;
}

export interface EditRoom {
    language: Language;
    order: number | null;
    layouts: UncertainImage[];
    images: UncertainImage[];
    name: string;
    nick: string;
    description: string | null;
    url: string | null;
}

export interface Survey {
    id: string;
    answerSections: AnswerSection[];
    createdAt: Date;
    name: string;
    email: string;
    phone: string;
    nps: number;
    comment: string;
    metaData: SurveyDetailsMetaData[];
}

export interface SurveyDetails {
    name: string;
    email: string;
    phone: string;
    nps: number;
    comment: string;
    metaData: SurveyDetailsMetaData[];
}

export interface SurveyDetailsMetaData {
    tag: string;
    value: string;
}

export interface AnswerSection {
    title: string;
    answers: Answer[];
}

export interface Answer {
    rate: number;
    comment: string;
    question: Question;
}

export interface NewAnswer {
    questionId: string;
    rate: number;
    comment: string;
}

export interface QuestionSection {
    id: string;
    title: string;
    questions: Question[];
}

export interface Question {
    id: string;
    title: string;
}

export interface QuestionStatsSection {
    title: string;
    questionStats: QuestionStats[];
}

export interface QuestionStats {
    question: Question;
    averageRate: number;
}

export interface SurveyStats {
    averageNps: number;
    averageRate: number;
    questionStatsSections: QuestionStatsSection[];
}

export enum StateUF {
    AC = "AC",
    AL = "AL",
    AP = "AP",
    AM = "AM",
    BA = "BA",
    CE = "CE",
    DF = "DF",
    ES = "ES",
    GO = "GO",
    MA = "MA",
    MT = "MT",
    MS = "MS",
    MG = "MG",
    PA = "PA",
    PB = "PB",
    PR = "PR",
    PE = "PE",
    PI = "PI",
    RJ = "RJ",
    RN = "RN",
    RS = "RS",
    RO = "RO",
    RR = "RR",
    SC = "SC",
    SP = "SP",
    SE = "SE",
    TO = "TO",
}

export function translateStateUF(enumStateUF: StateUF): string {
    switch (enumStateUF) {
        case StateUF.AC: {
            return strings ? strings["enum"]["StateUF"]["AC"] || StateUF.AC : StateUF.AC;
        }
        case StateUF.AL: {
            return strings ? strings["enum"]["StateUF"]["AL"] || StateUF.AL : StateUF.AL;
        }
        case StateUF.AP: {
            return strings ? strings["enum"]["StateUF"]["AP"] || StateUF.AP : StateUF.AP;
        }
        case StateUF.AM: {
            return strings ? strings["enum"]["StateUF"]["AM"] || StateUF.AM : StateUF.AM;
        }
        case StateUF.BA: {
            return strings ? strings["enum"]["StateUF"]["BA"] || StateUF.BA : StateUF.BA;
        }
        case StateUF.CE: {
            return strings ? strings["enum"]["StateUF"]["CE"] || StateUF.CE : StateUF.CE;
        }
        case StateUF.DF: {
            return strings ? strings["enum"]["StateUF"]["DF"] || StateUF.DF : StateUF.DF;
        }
        case StateUF.ES: {
            return strings ? strings["enum"]["StateUF"]["ES"] || StateUF.ES : StateUF.ES;
        }
        case StateUF.GO: {
            return strings ? strings["enum"]["StateUF"]["GO"] || StateUF.GO : StateUF.GO;
        }
        case StateUF.MA: {
            return strings ? strings["enum"]["StateUF"]["MA"] || StateUF.MA : StateUF.MA;
        }
        case StateUF.MT: {
            return strings ? strings["enum"]["StateUF"]["MT"] || StateUF.MT : StateUF.MT;
        }
        case StateUF.MS: {
            return strings ? strings["enum"]["StateUF"]["MS"] || StateUF.MS : StateUF.MS;
        }
        case StateUF.MG: {
            return strings ? strings["enum"]["StateUF"]["MG"] || StateUF.MG : StateUF.MG;
        }
        case StateUF.PA: {
            return strings ? strings["enum"]["StateUF"]["PA"] || StateUF.PA : StateUF.PA;
        }
        case StateUF.PB: {
            return strings ? strings["enum"]["StateUF"]["PB"] || StateUF.PB : StateUF.PB;
        }
        case StateUF.PR: {
            return strings ? strings["enum"]["StateUF"]["PR"] || StateUF.PR : StateUF.PR;
        }
        case StateUF.PE: {
            return strings ? strings["enum"]["StateUF"]["PE"] || StateUF.PE : StateUF.PE;
        }
        case StateUF.PI: {
            return strings ? strings["enum"]["StateUF"]["PI"] || StateUF.PI : StateUF.PI;
        }
        case StateUF.RJ: {
            return strings ? strings["enum"]["StateUF"]["RJ"] || StateUF.RJ : StateUF.RJ;
        }
        case StateUF.RN: {
            return strings ? strings["enum"]["StateUF"]["RN"] || StateUF.RN : StateUF.RN;
        }
        case StateUF.RS: {
            return strings ? strings["enum"]["StateUF"]["RS"] || StateUF.RS : StateUF.RS;
        }
        case StateUF.RO: {
            return strings ? strings["enum"]["StateUF"]["RO"] || StateUF.RO : StateUF.RO;
        }
        case StateUF.RR: {
            return strings ? strings["enum"]["StateUF"]["RR"] || StateUF.RR : StateUF.RR;
        }
        case StateUF.SC: {
            return strings ? strings["enum"]["StateUF"]["SC"] || StateUF.SC : StateUF.SC;
        }
        case StateUF.SP: {
            return strings ? strings["enum"]["StateUF"]["SP"] || StateUF.SP : StateUF.SP;
        }
        case StateUF.SE: {
            return strings ? strings["enum"]["StateUF"]["SE"] || StateUF.SE : StateUF.SE;
        }
        case StateUF.TO: {
            return strings ? strings["enum"]["StateUF"]["TO"] || StateUF.TO : StateUF.TO;
        }
    }
    return "";
}

export function allValuesStateUF(): StateUF[] {
    return [
        StateUF.AC,
        StateUF.AL,
        StateUF.AP,
        StateUF.AM,
        StateUF.BA,
        StateUF.CE,
        StateUF.DF,
        StateUF.ES,
        StateUF.GO,
        StateUF.MA,
        StateUF.MT,
        StateUF.MS,
        StateUF.MG,
        StateUF.PA,
        StateUF.PB,
        StateUF.PR,
        StateUF.PE,
        StateUF.PI,
        StateUF.RJ,
        StateUF.RN,
        StateUF.RS,
        StateUF.RO,
        StateUF.RR,
        StateUF.SC,
        StateUF.SP,
        StateUF.SE,
        StateUF.TO,
    ];
}

export function allTranslatedValuesStateUF(): string[] {
    return [
        translateStateUF(StateUF.AC),
        translateStateUF(StateUF.AL),
        translateStateUF(StateUF.AP),
        translateStateUF(StateUF.AM),
        translateStateUF(StateUF.BA),
        translateStateUF(StateUF.CE),
        translateStateUF(StateUF.DF),
        translateStateUF(StateUF.ES),
        translateStateUF(StateUF.GO),
        translateStateUF(StateUF.MA),
        translateStateUF(StateUF.MT),
        translateStateUF(StateUF.MS),
        translateStateUF(StateUF.MG),
        translateStateUF(StateUF.PA),
        translateStateUF(StateUF.PB),
        translateStateUF(StateUF.PR),
        translateStateUF(StateUF.PE),
        translateStateUF(StateUF.PI),
        translateStateUF(StateUF.RJ),
        translateStateUF(StateUF.RN),
        translateStateUF(StateUF.RS),
        translateStateUF(StateUF.RO),
        translateStateUF(StateUF.RR),
        translateStateUF(StateUF.SC),
        translateStateUF(StateUF.SP),
        translateStateUF(StateUF.SE),
        translateStateUF(StateUF.TO),
    ];
}

export function allDisplayableValuesStateUF(): string[] {
    return allTranslatedValuesStateUF().sort();
}

export function valueFromTranslationStateUF(translation: string): StateUF {
    const index = allTranslatedValuesStateUF().indexOf(translation);
    return allValuesStateUF()[index] || StateUF.AC;
}

export enum Language {
    ptBr = "ptBr",
    enUs = "enUs",
    esEs = "esEs",
}

export function translateLanguage(enumLanguage: Language): string {
    switch (enumLanguage) {
        case Language.ptBr: {
            return strings ? strings["enum"]["Language"]["ptBr"] || Language.ptBr : Language.ptBr;
        }
        case Language.enUs: {
            return strings ? strings["enum"]["Language"]["enUs"] || Language.enUs : Language.enUs;
        }
        case Language.esEs: {
            return strings ? strings["enum"]["Language"]["esEs"] || Language.esEs : Language.esEs;
        }
    }
    return "";
}

export function allValuesLanguage(): Language[] {
    return [
        Language.ptBr,
        Language.enUs,
        Language.esEs,
    ];
}

export function allTranslatedValuesLanguage(): string[] {
    return [
        translateLanguage(Language.ptBr),
        translateLanguage(Language.enUs),
        translateLanguage(Language.esEs),
    ];
}

export function allDisplayableValuesLanguage(): string[] {
    return allTranslatedValuesLanguage().sort();
}

export function valueFromTranslationLanguage(translation: string): Language {
    const index = allTranslatedValuesLanguage().indexOf(translation);
    return allValuesLanguage()[index] || Language.ptBr;
}

export enum ImageFormat {
    png = "png",
    jpeg = "jpeg",
}

export function translateImageFormat(enumImageFormat: ImageFormat): string {
    switch (enumImageFormat) {
        case ImageFormat.png: {
            return strings ? strings["enum"]["ImageFormat"]["png"] || ImageFormat.png : ImageFormat.png;
        }
        case ImageFormat.jpeg: {
            return strings ? strings["enum"]["ImageFormat"]["jpeg"] || ImageFormat.jpeg : ImageFormat.jpeg;
        }
    }
    return "";
}

export function allValuesImageFormat(): ImageFormat[] {
    return [
        ImageFormat.png,
        ImageFormat.jpeg,
    ];
}

export function allTranslatedValuesImageFormat(): string[] {
    return [
        translateImageFormat(ImageFormat.png),
        translateImageFormat(ImageFormat.jpeg),
    ];
}

export function allDisplayableValuesImageFormat(): string[] {
    return allTranslatedValuesImageFormat().sort();
}

export function valueFromTranslationImageFormat(translation: string): ImageFormat {
    const index = allTranslatedValuesImageFormat().indexOf(translation);
    return allValuesImageFormat()[index] || ImageFormat.png;
}

export enum BedroomConfort {
    bed = "bed",
    airConditioning = "airConditioning",
    safe = "safe",
    minibar = "minibar",
    tv = "tv",
    view = "view",
    bath = "bath",
    size = "size",
    roomService = "roomService",
    wifi = "wifi",
    livingRoom = "livingRoom",
    alarm = "alarm",
    layette = "layette",
    diningRoom = "diningRoom",
    pillows = "pillows",
}

export function translateBedroomConfort(enumBedroomConfort: BedroomConfort): string {
    switch (enumBedroomConfort) {
        case BedroomConfort.bed: {
            return strings ? strings["enum"]["BedroomConfort"]["bed"] || BedroomConfort.bed : BedroomConfort.bed;
        }
        case BedroomConfort.airConditioning: {
            return strings ? strings["enum"]["BedroomConfort"]["airConditioning"] || BedroomConfort.airConditioning : BedroomConfort.airConditioning;
        }
        case BedroomConfort.safe: {
            return strings ? strings["enum"]["BedroomConfort"]["safe"] || BedroomConfort.safe : BedroomConfort.safe;
        }
        case BedroomConfort.minibar: {
            return strings ? strings["enum"]["BedroomConfort"]["minibar"] || BedroomConfort.minibar : BedroomConfort.minibar;
        }
        case BedroomConfort.tv: {
            return strings ? strings["enum"]["BedroomConfort"]["tv"] || BedroomConfort.tv : BedroomConfort.tv;
        }
        case BedroomConfort.view: {
            return strings ? strings["enum"]["BedroomConfort"]["view"] || BedroomConfort.view : BedroomConfort.view;
        }
        case BedroomConfort.bath: {
            return strings ? strings["enum"]["BedroomConfort"]["bath"] || BedroomConfort.bath : BedroomConfort.bath;
        }
        case BedroomConfort.size: {
            return strings ? strings["enum"]["BedroomConfort"]["size"] || BedroomConfort.size : BedroomConfort.size;
        }
        case BedroomConfort.roomService: {
            return strings ? strings["enum"]["BedroomConfort"]["roomService"] || BedroomConfort.roomService : BedroomConfort.roomService;
        }
        case BedroomConfort.wifi: {
            return strings ? strings["enum"]["BedroomConfort"]["wifi"] || BedroomConfort.wifi : BedroomConfort.wifi;
        }
        case BedroomConfort.livingRoom: {
            return strings ? strings["enum"]["BedroomConfort"]["livingRoom"] || BedroomConfort.livingRoom : BedroomConfort.livingRoom;
        }
        case BedroomConfort.alarm: {
            return strings ? strings["enum"]["BedroomConfort"]["alarm"] || BedroomConfort.alarm : BedroomConfort.alarm;
        }
        case BedroomConfort.layette: {
            return strings ? strings["enum"]["BedroomConfort"]["layette"] || BedroomConfort.layette : BedroomConfort.layette;
        }
        case BedroomConfort.diningRoom: {
            return strings ? strings["enum"]["BedroomConfort"]["diningRoom"] || BedroomConfort.diningRoom : BedroomConfort.diningRoom;
        }
        case BedroomConfort.pillows: {
            return strings ? strings["enum"]["BedroomConfort"]["pillows"] || BedroomConfort.pillows : BedroomConfort.pillows;
        }
    }
    return "";
}

export function allValuesBedroomConfort(): BedroomConfort[] {
    return [
        BedroomConfort.bed,
        BedroomConfort.airConditioning,
        BedroomConfort.safe,
        BedroomConfort.minibar,
        BedroomConfort.tv,
        BedroomConfort.view,
        BedroomConfort.bath,
        BedroomConfort.size,
        BedroomConfort.roomService,
        BedroomConfort.wifi,
        BedroomConfort.livingRoom,
        BedroomConfort.alarm,
        BedroomConfort.layette,
        BedroomConfort.diningRoom,
        BedroomConfort.pillows,
    ];
}

export function allTranslatedValuesBedroomConfort(): string[] {
    return [
        translateBedroomConfort(BedroomConfort.bed),
        translateBedroomConfort(BedroomConfort.airConditioning),
        translateBedroomConfort(BedroomConfort.safe),
        translateBedroomConfort(BedroomConfort.minibar),
        translateBedroomConfort(BedroomConfort.tv),
        translateBedroomConfort(BedroomConfort.view),
        translateBedroomConfort(BedroomConfort.bath),
        translateBedroomConfort(BedroomConfort.size),
        translateBedroomConfort(BedroomConfort.roomService),
        translateBedroomConfort(BedroomConfort.wifi),
        translateBedroomConfort(BedroomConfort.livingRoom),
        translateBedroomConfort(BedroomConfort.alarm),
        translateBedroomConfort(BedroomConfort.layette),
        translateBedroomConfort(BedroomConfort.diningRoom),
        translateBedroomConfort(BedroomConfort.pillows),
    ];
}

export function allDisplayableValuesBedroomConfort(): string[] {
    return allTranslatedValuesBedroomConfort().sort();
}

export function valueFromTranslationBedroomConfort(translation: string): BedroomConfort {
    const index = allTranslatedValuesBedroomConfort().indexOf(translation);
    return allValuesBedroomConfort()[index] || BedroomConfort.bed;
}

export enum EventType {
    wedding = "wedding",
    socialEvent = "socialEvent",
    corporativeEvent = "corporativeEvent",
}

export function translateEventType(enumEventType: EventType): string {
    switch (enumEventType) {
        case EventType.wedding: {
            return strings ? strings["enum"]["EventType"]["wedding"] || EventType.wedding : EventType.wedding;
        }
        case EventType.socialEvent: {
            return strings ? strings["enum"]["EventType"]["socialEvent"] || EventType.socialEvent : EventType.socialEvent;
        }
        case EventType.corporativeEvent: {
            return strings ? strings["enum"]["EventType"]["corporativeEvent"] || EventType.corporativeEvent : EventType.corporativeEvent;
        }
    }
    return "";
}

export function allValuesEventType(): EventType[] {
    return [
        EventType.wedding,
        EventType.socialEvent,
        EventType.corporativeEvent,
    ];
}

export function allTranslatedValuesEventType(): string[] {
    return [
        translateEventType(EventType.wedding),
        translateEventType(EventType.socialEvent),
        translateEventType(EventType.corporativeEvent),
    ];
}

export function allDisplayableValuesEventType(): string[] {
    return allTranslatedValuesEventType().sort();
}

export function valueFromTranslationEventType(translation: string): EventType {
    const index = allTranslatedValuesEventType().indexOf(translation);
    return allValuesEventType()[index] || EventType.wedding;
}

export enum RoomFormat {
    uFormat = "uFormat",
    schoolar = "schoolar",
    auditorium = "auditorium",
    roudedTable = "roudedTable",
    cocktail = "cocktail",
    fishbone = "fishbone",
}

export function translateRoomFormat(enumRoomFormat: RoomFormat): string {
    switch (enumRoomFormat) {
        case RoomFormat.uFormat: {
            return strings ? strings["enum"]["RoomFormat"]["uFormat"] || RoomFormat.uFormat : RoomFormat.uFormat;
        }
        case RoomFormat.schoolar: {
            return strings ? strings["enum"]["RoomFormat"]["schoolar"] || RoomFormat.schoolar : RoomFormat.schoolar;
        }
        case RoomFormat.auditorium: {
            return strings ? strings["enum"]["RoomFormat"]["auditorium"] || RoomFormat.auditorium : RoomFormat.auditorium;
        }
        case RoomFormat.roudedTable: {
            return strings ? strings["enum"]["RoomFormat"]["roudedTable"] || RoomFormat.roudedTable : RoomFormat.roudedTable;
        }
        case RoomFormat.cocktail: {
            return strings ? strings["enum"]["RoomFormat"]["cocktail"] || RoomFormat.cocktail : RoomFormat.cocktail;
        }
        case RoomFormat.fishbone: {
            return strings ? strings["enum"]["RoomFormat"]["fishbone"] || RoomFormat.fishbone : RoomFormat.fishbone;
        }
    }
    return "";
}

export function allValuesRoomFormat(): RoomFormat[] {
    return [
        RoomFormat.uFormat,
        RoomFormat.schoolar,
        RoomFormat.auditorium,
        RoomFormat.roudedTable,
        RoomFormat.cocktail,
        RoomFormat.fishbone,
    ];
}

export function allTranslatedValuesRoomFormat(): string[] {
    return [
        translateRoomFormat(RoomFormat.uFormat),
        translateRoomFormat(RoomFormat.schoolar),
        translateRoomFormat(RoomFormat.auditorium),
        translateRoomFormat(RoomFormat.roudedTable),
        translateRoomFormat(RoomFormat.cocktail),
        translateRoomFormat(RoomFormat.fishbone),
    ];
}

export function allDisplayableValuesRoomFormat(): string[] {
    return allTranslatedValuesRoomFormat().sort();
}

export function valueFromTranslationRoomFormat(translation: string): RoomFormat {
    const index = allTranslatedValuesRoomFormat().indexOf(translation);
    return allValuesRoomFormat()[index] || RoomFormat.uFormat;
}

export enum GastroPlaceType {
    bar = "bar",
    restaurant = "restaurant",
}

export function translateGastroPlaceType(enumGastroPlaceType: GastroPlaceType): string {
    switch (enumGastroPlaceType) {
        case GastroPlaceType.bar: {
            return strings ? strings["enum"]["GastroPlaceType"]["bar"] || GastroPlaceType.bar : GastroPlaceType.bar;
        }
        case GastroPlaceType.restaurant: {
            return strings ? strings["enum"]["GastroPlaceType"]["restaurant"] || GastroPlaceType.restaurant : GastroPlaceType.restaurant;
        }
    }
    return "";
}

export function allValuesGastroPlaceType(): GastroPlaceType[] {
    return [
        GastroPlaceType.bar,
        GastroPlaceType.restaurant,
    ];
}

export function allTranslatedValuesGastroPlaceType(): string[] {
    return [
        translateGastroPlaceType(GastroPlaceType.bar),
        translateGastroPlaceType(GastroPlaceType.restaurant),
    ];
}

export function allDisplayableValuesGastroPlaceType(): string[] {
    return allTranslatedValuesGastroPlaceType().sort();
}

export function valueFromTranslationGastroPlaceType(translation: string): GastroPlaceType {
    const index = allTranslatedValuesGastroPlaceType().indexOf(translation);
    return allValuesGastroPlaceType()[index] || GastroPlaceType.bar;
}

export enum ErrorType {
    NotFound = "NotFound",
    InvalidArgument = "InvalidArgument",
    MissingArgument = "MissingArgument",
    MaximumExceded = "MaximumExceded",
    WrongLoginOrPassword = "WrongLoginOrPassword",
    NotLoggedIn = "NotLoggedIn",
    ExpiredResetPasswordToken = "ExpiredResetPasswordToken",
    AccessNotAllowed = "AccessNotAllowed",
    EmailAlreadyInUse = "EmailAlreadyInUse",
    InvalidEmail = "InvalidEmail",
    NickAlreadyInUse = "NickAlreadyInUse",
    InvalidNick = "InvalidNick",
    InvalidUrl = "InvalidUrl",
    Fatal = "Fatal",
    Connection = "Connection",
}

export function translateErrorType(enumErrorType: ErrorType): string {
    switch (enumErrorType) {
        case ErrorType.NotFound: {
            return strings ? strings["enum"]["ErrorType"]["NotFound"] || ErrorType.NotFound : ErrorType.NotFound;
        }
        case ErrorType.InvalidArgument: {
            return strings ? strings["enum"]["ErrorType"]["InvalidArgument"] || ErrorType.InvalidArgument : ErrorType.InvalidArgument;
        }
        case ErrorType.MissingArgument: {
            return strings ? strings["enum"]["ErrorType"]["MissingArgument"] || ErrorType.MissingArgument : ErrorType.MissingArgument;
        }
        case ErrorType.MaximumExceded: {
            return strings ? strings["enum"]["ErrorType"]["MaximumExceded"] || ErrorType.MaximumExceded : ErrorType.MaximumExceded;
        }
        case ErrorType.WrongLoginOrPassword: {
            return strings ? strings["enum"]["ErrorType"]["WrongLoginOrPassword"] || ErrorType.WrongLoginOrPassword : ErrorType.WrongLoginOrPassword;
        }
        case ErrorType.NotLoggedIn: {
            return strings ? strings["enum"]["ErrorType"]["NotLoggedIn"] || ErrorType.NotLoggedIn : ErrorType.NotLoggedIn;
        }
        case ErrorType.ExpiredResetPasswordToken: {
            return strings ? strings["enum"]["ErrorType"]["ExpiredResetPasswordToken"] || ErrorType.ExpiredResetPasswordToken : ErrorType.ExpiredResetPasswordToken;
        }
        case ErrorType.AccessNotAllowed: {
            return strings ? strings["enum"]["ErrorType"]["AccessNotAllowed"] || ErrorType.AccessNotAllowed : ErrorType.AccessNotAllowed;
        }
        case ErrorType.EmailAlreadyInUse: {
            return strings ? strings["enum"]["ErrorType"]["EmailAlreadyInUse"] || ErrorType.EmailAlreadyInUse : ErrorType.EmailAlreadyInUse;
        }
        case ErrorType.InvalidEmail: {
            return strings ? strings["enum"]["ErrorType"]["InvalidEmail"] || ErrorType.InvalidEmail : ErrorType.InvalidEmail;
        }
        case ErrorType.NickAlreadyInUse: {
            return strings ? strings["enum"]["ErrorType"]["NickAlreadyInUse"] || ErrorType.NickAlreadyInUse : ErrorType.NickAlreadyInUse;
        }
        case ErrorType.InvalidNick: {
            return strings ? strings["enum"]["ErrorType"]["InvalidNick"] || ErrorType.InvalidNick : ErrorType.InvalidNick;
        }
        case ErrorType.InvalidUrl: {
            return strings ? strings["enum"]["ErrorType"]["InvalidUrl"] || ErrorType.InvalidUrl : ErrorType.InvalidUrl;
        }
        case ErrorType.Fatal: {
            return strings ? strings["enum"]["ErrorType"]["Fatal"] || ErrorType.Fatal : ErrorType.Fatal;
        }
        case ErrorType.Connection: {
            return strings ? strings["enum"]["ErrorType"]["Connection"] || ErrorType.Connection : ErrorType.Connection;
        }
    }
    return "";
}

export function allValuesErrorType(): ErrorType[] {
    return [
        ErrorType.NotFound,
        ErrorType.InvalidArgument,
        ErrorType.MissingArgument,
        ErrorType.MaximumExceded,
        ErrorType.WrongLoginOrPassword,
        ErrorType.NotLoggedIn,
        ErrorType.ExpiredResetPasswordToken,
        ErrorType.AccessNotAllowed,
        ErrorType.EmailAlreadyInUse,
        ErrorType.InvalidEmail,
        ErrorType.NickAlreadyInUse,
        ErrorType.InvalidNick,
        ErrorType.InvalidUrl,
        ErrorType.Fatal,
        ErrorType.Connection,
    ];
}

export function allTranslatedValuesErrorType(): string[] {
    return [
        translateErrorType(ErrorType.NotFound),
        translateErrorType(ErrorType.InvalidArgument),
        translateErrorType(ErrorType.MissingArgument),
        translateErrorType(ErrorType.MaximumExceded),
        translateErrorType(ErrorType.WrongLoginOrPassword),
        translateErrorType(ErrorType.NotLoggedIn),
        translateErrorType(ErrorType.ExpiredResetPasswordToken),
        translateErrorType(ErrorType.AccessNotAllowed),
        translateErrorType(ErrorType.EmailAlreadyInUse),
        translateErrorType(ErrorType.InvalidEmail),
        translateErrorType(ErrorType.NickAlreadyInUse),
        translateErrorType(ErrorType.InvalidNick),
        translateErrorType(ErrorType.InvalidUrl),
        translateErrorType(ErrorType.Fatal),
        translateErrorType(ErrorType.Connection),
    ];
}

export function allDisplayableValuesErrorType(): string[] {
    return allTranslatedValuesErrorType().sort();
}

export function valueFromTranslationErrorType(translation: string): ErrorType {
    const index = allTranslatedValuesErrorType().indexOf(translation);
    return allValuesErrorType()[index] || ErrorType.NotFound;
}

export async function uploadImage(image: Buffer, format: ImageFormat | null, crop: Crop | null, progress?: (progress: number) => void): Promise<Image> {
    const args = {
        image: image.toString("base64"),
        format: format === null || format === undefined ? null : format,
        crop: crop === null || crop === undefined ? null : {
            x: crop.x || 0,
            y: crop.y || 0,
            width: crop.width || 0,
            height: crop.height || 0,
        },
    };
    const ret = await makeRequest({name: "uploadImage", args, progress});
    return {
        thumb: {
            width: ret.thumb.width || 0,
            height: ret.thumb.height || 0,
            url: ret.thumb.url,
        },
        width: ret.width || 0,
        height: ret.height || 0,
        url: ret.url,
    };
}

export async function cropImage(src: string, crop: Crop, progress?: (progress: number) => void): Promise<Image> {
    const args = {
        src: src,
        crop: {
            x: crop.x || 0,
            y: crop.y || 0,
            width: crop.width || 0,
            height: crop.height || 0,
        },
    };
    const ret = await makeRequest({name: "cropImage", args, progress});
    return {
        thumb: {
            width: ret.thumb.width || 0,
            height: ret.thumb.height || 0,
            url: ret.thumb.url,
        },
        width: ret.width || 0,
        height: ret.height || 0,
        url: ret.url,
    };
}

export async function uploadFile(file: UploadFile, progress?: (progress: number) => void): Promise<File> {
    const args = {
        file: {
            bytes: file.bytes.toString("base64"),
            name: file.name,
        },
    };
    const ret = await makeRequest({name: "uploadFile", args, progress});
    return {
        name: ret.name,
        url: ret.url,
    };
}

export async function getHotel(hotelId: string, progress?: (progress: number) => void): Promise<Hotel> {
    const args = {
        hotelId: hotelId,
    };
    const ret = await makeRequest({name: "getHotel", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                name: e.translation.name,
                slogan: e.translation.slogan === null || e.translation.slogan === undefined ? null : e.translation.slogan,
                description: e.translation.description,
                roomsDescription: e.translation.roomsDescription === null || e.translation.roomsDescription === undefined ? null : e.translation.roomsDescription,
            },
        })),
        colors: {
            primary: ret.colors.primary,
            secondary: ret.colors.secondary,
            tertiary: ret.colors.tertiary === null || ret.colors.tertiary === undefined ? null : ret.colors.tertiary,
            background: ret.colors.background,
            textPrimary: ret.colors.textPrimary,
            textSecondary: ret.colors.textSecondary === null || ret.colors.textSecondary === undefined ? null : ret.colors.textSecondary,
            textTertiary: ret.colors.textTertiary === null || ret.colors.textTertiary === undefined ? null : ret.colors.textTertiary,
        },
        logos: {
            horizontal: {
                thumb: {
                    width: ret.logos.horizontal.thumb.width || 0,
                    height: ret.logos.horizontal.thumb.height || 0,
                    url: ret.logos.horizontal.thumb.url,
                },
                width: ret.logos.horizontal.width || 0,
                height: ret.logos.horizontal.height || 0,
                url: ret.logos.horizontal.url,
            },
            squared: {
                thumb: {
                    width: ret.logos.squared.thumb.width || 0,
                    height: ret.logos.squared.thumb.height || 0,
                    url: ret.logos.squared.thumb.url,
                },
                width: ret.logos.squared.width || 0,
                height: ret.logos.squared.height || 0,
                url: ret.logos.squared.url,
            },
            white: ret.logos.white === null || ret.logos.white === undefined ? null : {
                thumb: {
                    width: ret.logos.white.thumb.width || 0,
                    height: ret.logos.white.thumb.height || 0,
                    url: ret.logos.white.thumb.url,
                },
                width: ret.logos.white.width || 0,
                height: ret.logos.white.height || 0,
                url: ret.logos.white.url,
            },
        },
        videoUrl: ret.videoUrl,
        email: ret.email,
        phone: ret.phone,
        socialMedia: {
            instagram: ret.socialMedia.instagram === null || ret.socialMedia.instagram === undefined ? null : ret.socialMedia.instagram,
            facebook: ret.socialMedia.facebook === null || ret.socialMedia.facebook === undefined ? null : ret.socialMedia.facebook,
            linkedin: ret.socialMedia.linkedin === null || ret.socialMedia.linkedin === undefined ? null : ret.socialMedia.linkedin,
        },
        address: {
            cep: ret.address.cep,
            number: ret.address.number,
            street: ret.address.street,
            neighborhood: ret.address.neighborhood,
            city: ret.address.city,
            cityId: ret.address.cityId === null || ret.address.cityId === undefined ? null : ret.address.cityId,
            state: ret.address.state,
            uf: ret.address.uf,
            latLng: {
                lat: ret.address.latLng.lat,
                lng: ret.address.latLng.lng,
            },
        },
        reserveDisponibility: {
            start: ret.reserveDisponibility.start || 0,
            end: ret.reserveDisponibility.end || 0,
        },
        omnibeesId: ret.omnibeesId,
        metaTags: ret.metaTags.map((e: any) => e),
    };
}

export async function getCurrentAdminUser(progress?: (progress: number) => void): Promise<AdminUser> {
    const ret = await makeRequest({name: "getCurrentAdminUser", args: {}, progress});
    return {
        id: ret.id,
        hotel: {
            id: ret.hotel.id,
            languages: ret.hotel.languages.map((e: any) => ({
                language: e.language,
                translation: {
                    image: {
                        thumb: {
                            width: e.translation.image.thumb.width || 0,
                            height: e.translation.image.thumb.height || 0,
                            url: e.translation.image.thumb.url,
                        },
                        width: e.translation.image.width || 0,
                        height: e.translation.image.height || 0,
                        url: e.translation.image.url,
                    },
                    nick: e.translation.nick,
                    name: e.translation.name,
                    slogan: e.translation.slogan === null || e.translation.slogan === undefined ? null : e.translation.slogan,
                    description: e.translation.description,
                    roomsDescription: e.translation.roomsDescription === null || e.translation.roomsDescription === undefined ? null : e.translation.roomsDescription,
                },
            })),
            colors: {
                primary: ret.hotel.colors.primary,
                secondary: ret.hotel.colors.secondary,
                tertiary: ret.hotel.colors.tertiary === null || ret.hotel.colors.tertiary === undefined ? null : ret.hotel.colors.tertiary,
                background: ret.hotel.colors.background,
                textPrimary: ret.hotel.colors.textPrimary,
                textSecondary: ret.hotel.colors.textSecondary === null || ret.hotel.colors.textSecondary === undefined ? null : ret.hotel.colors.textSecondary,
                textTertiary: ret.hotel.colors.textTertiary === null || ret.hotel.colors.textTertiary === undefined ? null : ret.hotel.colors.textTertiary,
            },
            logos: {
                horizontal: {
                    thumb: {
                        width: ret.hotel.logos.horizontal.thumb.width || 0,
                        height: ret.hotel.logos.horizontal.thumb.height || 0,
                        url: ret.hotel.logos.horizontal.thumb.url,
                    },
                    width: ret.hotel.logos.horizontal.width || 0,
                    height: ret.hotel.logos.horizontal.height || 0,
                    url: ret.hotel.logos.horizontal.url,
                },
                squared: {
                    thumb: {
                        width: ret.hotel.logos.squared.thumb.width || 0,
                        height: ret.hotel.logos.squared.thumb.height || 0,
                        url: ret.hotel.logos.squared.thumb.url,
                    },
                    width: ret.hotel.logos.squared.width || 0,
                    height: ret.hotel.logos.squared.height || 0,
                    url: ret.hotel.logos.squared.url,
                },
                white: ret.hotel.logos.white === null || ret.hotel.logos.white === undefined ? null : {
                    thumb: {
                        width: ret.hotel.logos.white.thumb.width || 0,
                        height: ret.hotel.logos.white.thumb.height || 0,
                        url: ret.hotel.logos.white.thumb.url,
                    },
                    width: ret.hotel.logos.white.width || 0,
                    height: ret.hotel.logos.white.height || 0,
                    url: ret.hotel.logos.white.url,
                },
            },
            videoUrl: ret.hotel.videoUrl,
            email: ret.hotel.email,
            phone: ret.hotel.phone,
            socialMedia: {
                instagram: ret.hotel.socialMedia.instagram === null || ret.hotel.socialMedia.instagram === undefined ? null : ret.hotel.socialMedia.instagram,
                facebook: ret.hotel.socialMedia.facebook === null || ret.hotel.socialMedia.facebook === undefined ? null : ret.hotel.socialMedia.facebook,
                linkedin: ret.hotel.socialMedia.linkedin === null || ret.hotel.socialMedia.linkedin === undefined ? null : ret.hotel.socialMedia.linkedin,
            },
            address: {
                cep: ret.hotel.address.cep,
                number: ret.hotel.address.number,
                street: ret.hotel.address.street,
                neighborhood: ret.hotel.address.neighborhood,
                city: ret.hotel.address.city,
                cityId: ret.hotel.address.cityId === null || ret.hotel.address.cityId === undefined ? null : ret.hotel.address.cityId,
                state: ret.hotel.address.state,
                uf: ret.hotel.address.uf,
                latLng: {
                    lat: ret.hotel.address.latLng.lat,
                    lng: ret.hotel.address.latLng.lng,
                },
            },
            reserveDisponibility: {
                start: ret.hotel.reserveDisponibility.start || 0,
                end: ret.hotel.reserveDisponibility.end || 0,
            },
            omnibeesId: ret.hotel.omnibeesId,
            metaTags: ret.hotel.metaTags.map((e: any) => e),
        },
        name: ret.name,
        email: ret.email,
    };
}

export async function login(email: string, password: string, progress?: (progress: number) => void): Promise<AdminUser> {
    const args = {
        email: email,
        password: password,
    };
    const ret = await makeRequest({name: "login", args, progress});
    return {
        id: ret.id,
        hotel: {
            id: ret.hotel.id,
            languages: ret.hotel.languages.map((e: any) => ({
                language: e.language,
                translation: {
                    image: {
                        thumb: {
                            width: e.translation.image.thumb.width || 0,
                            height: e.translation.image.thumb.height || 0,
                            url: e.translation.image.thumb.url,
                        },
                        width: e.translation.image.width || 0,
                        height: e.translation.image.height || 0,
                        url: e.translation.image.url,
                    },
                    nick: e.translation.nick,
                    name: e.translation.name,
                    slogan: e.translation.slogan === null || e.translation.slogan === undefined ? null : e.translation.slogan,
                    description: e.translation.description,
                    roomsDescription: e.translation.roomsDescription === null || e.translation.roomsDescription === undefined ? null : e.translation.roomsDescription,
                },
            })),
            colors: {
                primary: ret.hotel.colors.primary,
                secondary: ret.hotel.colors.secondary,
                tertiary: ret.hotel.colors.tertiary === null || ret.hotel.colors.tertiary === undefined ? null : ret.hotel.colors.tertiary,
                background: ret.hotel.colors.background,
                textPrimary: ret.hotel.colors.textPrimary,
                textSecondary: ret.hotel.colors.textSecondary === null || ret.hotel.colors.textSecondary === undefined ? null : ret.hotel.colors.textSecondary,
                textTertiary: ret.hotel.colors.textTertiary === null || ret.hotel.colors.textTertiary === undefined ? null : ret.hotel.colors.textTertiary,
            },
            logos: {
                horizontal: {
                    thumb: {
                        width: ret.hotel.logos.horizontal.thumb.width || 0,
                        height: ret.hotel.logos.horizontal.thumb.height || 0,
                        url: ret.hotel.logos.horizontal.thumb.url,
                    },
                    width: ret.hotel.logos.horizontal.width || 0,
                    height: ret.hotel.logos.horizontal.height || 0,
                    url: ret.hotel.logos.horizontal.url,
                },
                squared: {
                    thumb: {
                        width: ret.hotel.logos.squared.thumb.width || 0,
                        height: ret.hotel.logos.squared.thumb.height || 0,
                        url: ret.hotel.logos.squared.thumb.url,
                    },
                    width: ret.hotel.logos.squared.width || 0,
                    height: ret.hotel.logos.squared.height || 0,
                    url: ret.hotel.logos.squared.url,
                },
                white: ret.hotel.logos.white === null || ret.hotel.logos.white === undefined ? null : {
                    thumb: {
                        width: ret.hotel.logos.white.thumb.width || 0,
                        height: ret.hotel.logos.white.thumb.height || 0,
                        url: ret.hotel.logos.white.thumb.url,
                    },
                    width: ret.hotel.logos.white.width || 0,
                    height: ret.hotel.logos.white.height || 0,
                    url: ret.hotel.logos.white.url,
                },
            },
            videoUrl: ret.hotel.videoUrl,
            email: ret.hotel.email,
            phone: ret.hotel.phone,
            socialMedia: {
                instagram: ret.hotel.socialMedia.instagram === null || ret.hotel.socialMedia.instagram === undefined ? null : ret.hotel.socialMedia.instagram,
                facebook: ret.hotel.socialMedia.facebook === null || ret.hotel.socialMedia.facebook === undefined ? null : ret.hotel.socialMedia.facebook,
                linkedin: ret.hotel.socialMedia.linkedin === null || ret.hotel.socialMedia.linkedin === undefined ? null : ret.hotel.socialMedia.linkedin,
            },
            address: {
                cep: ret.hotel.address.cep,
                number: ret.hotel.address.number,
                street: ret.hotel.address.street,
                neighborhood: ret.hotel.address.neighborhood,
                city: ret.hotel.address.city,
                cityId: ret.hotel.address.cityId === null || ret.hotel.address.cityId === undefined ? null : ret.hotel.address.cityId,
                state: ret.hotel.address.state,
                uf: ret.hotel.address.uf,
                latLng: {
                    lat: ret.hotel.address.latLng.lat,
                    lng: ret.hotel.address.latLng.lng,
                },
            },
            reserveDisponibility: {
                start: ret.hotel.reserveDisponibility.start || 0,
                end: ret.hotel.reserveDisponibility.end || 0,
            },
            omnibeesId: ret.hotel.omnibeesId,
            metaTags: ret.hotel.metaTags.map((e: any) => e),
        },
        name: ret.name,
        email: ret.email,
    };
}

export async function logout(progress?: (progress: number) => void): Promise<void> {
    await makeRequest({name: "logout", args: {}, progress});
    return undefined;
}

export async function sendResetPasswordEmailAdminUser(email: string, progress?: (progress: number) => void): Promise<void> {
    const args = {
        email: email,
    };
    await makeRequest({name: "sendResetPasswordEmailAdminUser", args, progress});
    return undefined;
}

export async function resetPasswordEmailAdminUser(token: string, newPassword: string, progress?: (progress: number) => void): Promise<void> {
    const args = {
        token: token,
        newPassword: newPassword,
    };
    await makeRequest({name: "resetPasswordEmailAdminUser", args, progress});
    return undefined;
}

export async function getBanners(pageOffset: number, progress?: (progress: number) => void): Promise<Banner[]> {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({name: "getBanners", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                mobileImage: e.translation.mobileImage === null || e.translation.mobileImage === undefined ? null : {
                    thumb: {
                        width: e.translation.mobileImage.thumb.width || 0,
                        height: e.translation.mobileImage.thumb.height || 0,
                        url: e.translation.mobileImage.thumb.url,
                    },
                    width: e.translation.mobileImage.width || 0,
                    height: e.translation.mobileImage.height || 0,
                    url: e.translation.mobileImage.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    }));
}

export async function getBanner(bannerId: string, progress?: (progress: number) => void): Promise<Banner> {
    const args = {
        bannerId: bannerId,
    };
    const ret = await makeRequest({name: "getBanner", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                mobileImage: e.translation.mobileImage === null || e.translation.mobileImage === undefined ? null : {
                    thumb: {
                        width: e.translation.mobileImage.thumb.width || 0,
                        height: e.translation.mobileImage.thumb.height || 0,
                        url: e.translation.mobileImage.thumb.url,
                    },
                    width: e.translation.mobileImage.width || 0,
                    height: e.translation.mobileImage.height || 0,
                    url: e.translation.mobileImage.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    };
}

export async function getAllBanners(hotelId: string, progress?: (progress: number) => void): Promise<Banner[]> {
    const args = {
        hotelId: hotelId,
    };
    const ret = await makeRequest({name: "getAllBanners", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                mobileImage: e.translation.mobileImage === null || e.translation.mobileImage === undefined ? null : {
                    thumb: {
                        width: e.translation.mobileImage.thumb.width || 0,
                        height: e.translation.mobileImage.thumb.height || 0,
                        url: e.translation.mobileImage.thumb.url,
                    },
                    width: e.translation.mobileImage.width || 0,
                    height: e.translation.mobileImage.height || 0,
                    url: e.translation.mobileImage.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    }));
}

export async function createBanner(newBanner: NewBanner, progress?: (progress: number) => void): Promise<Banner> {
    const args = {
        newBanner: {
            image: {
                bytes: newBanner.image.bytes === null || newBanner.image.bytes === undefined ? null : newBanner.image.bytes.toString("base64"),
                image: newBanner.image.image === null || newBanner.image.image === undefined ? null : {
                    thumb: {
                        width: newBanner.image.image.thumb.width || 0,
                        height: newBanner.image.image.thumb.height || 0,
                        url: newBanner.image.image.thumb.url,
                    },
                    width: newBanner.image.image.width || 0,
                    height: newBanner.image.image.height || 0,
                    url: newBanner.image.image.url,
                },
                crop: newBanner.image.crop === null || newBanner.image.crop === undefined ? null : {
                    x: newBanner.image.crop.x || 0,
                    y: newBanner.image.crop.y || 0,
                    width: newBanner.image.crop.width || 0,
                    height: newBanner.image.crop.height || 0,
                },
            },
            mobileImage: newBanner.mobileImage === null || newBanner.mobileImage === undefined ? null : {
                bytes: newBanner.mobileImage.bytes === null || newBanner.mobileImage.bytes === undefined ? null : newBanner.mobileImage.bytes.toString("base64"),
                image: newBanner.mobileImage.image === null || newBanner.mobileImage.image === undefined ? null : {
                    thumb: {
                        width: newBanner.mobileImage.image.thumb.width || 0,
                        height: newBanner.mobileImage.image.thumb.height || 0,
                        url: newBanner.mobileImage.image.thumb.url,
                    },
                    width: newBanner.mobileImage.image.width || 0,
                    height: newBanner.mobileImage.image.height || 0,
                    url: newBanner.mobileImage.image.url,
                },
                crop: newBanner.mobileImage.crop === null || newBanner.mobileImage.crop === undefined ? null : {
                    x: newBanner.mobileImage.crop.x || 0,
                    y: newBanner.mobileImage.crop.y || 0,
                    width: newBanner.mobileImage.crop.width || 0,
                    height: newBanner.mobileImage.crop.height || 0,
                },
            },
            nick: newBanner.nick,
            title: newBanner.title,
            description: newBanner.description === null || newBanner.description === undefined ? null : newBanner.description,
            url: newBanner.url === null || newBanner.url === undefined ? null : newBanner.url,
        },
    };
    const ret = await makeRequest({name: "createBanner", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                mobileImage: e.translation.mobileImage === null || e.translation.mobileImage === undefined ? null : {
                    thumb: {
                        width: e.translation.mobileImage.thumb.width || 0,
                        height: e.translation.mobileImage.thumb.height || 0,
                        url: e.translation.mobileImage.thumb.url,
                    },
                    width: e.translation.mobileImage.width || 0,
                    height: e.translation.mobileImage.height || 0,
                    url: e.translation.mobileImage.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    };
}

export async function editBanner(bannerId: string, editedBanner: EditBanner, progress?: (progress: number) => void): Promise<Banner> {
    const args = {
        bannerId: bannerId,
        editedBanner: {
            language: editedBanner.language,
            image: {
                bytes: editedBanner.image.bytes === null || editedBanner.image.bytes === undefined ? null : editedBanner.image.bytes.toString("base64"),
                image: editedBanner.image.image === null || editedBanner.image.image === undefined ? null : {
                    thumb: {
                        width: editedBanner.image.image.thumb.width || 0,
                        height: editedBanner.image.image.thumb.height || 0,
                        url: editedBanner.image.image.thumb.url,
                    },
                    width: editedBanner.image.image.width || 0,
                    height: editedBanner.image.image.height || 0,
                    url: editedBanner.image.image.url,
                },
                crop: editedBanner.image.crop === null || editedBanner.image.crop === undefined ? null : {
                    x: editedBanner.image.crop.x || 0,
                    y: editedBanner.image.crop.y || 0,
                    width: editedBanner.image.crop.width || 0,
                    height: editedBanner.image.crop.height || 0,
                },
            },
            mobileImage: editedBanner.mobileImage === null || editedBanner.mobileImage === undefined ? null : {
                bytes: editedBanner.mobileImage.bytes === null || editedBanner.mobileImage.bytes === undefined ? null : editedBanner.mobileImage.bytes.toString("base64"),
                image: editedBanner.mobileImage.image === null || editedBanner.mobileImage.image === undefined ? null : {
                    thumb: {
                        width: editedBanner.mobileImage.image.thumb.width || 0,
                        height: editedBanner.mobileImage.image.thumb.height || 0,
                        url: editedBanner.mobileImage.image.thumb.url,
                    },
                    width: editedBanner.mobileImage.image.width || 0,
                    height: editedBanner.mobileImage.image.height || 0,
                    url: editedBanner.mobileImage.image.url,
                },
                crop: editedBanner.mobileImage.crop === null || editedBanner.mobileImage.crop === undefined ? null : {
                    x: editedBanner.mobileImage.crop.x || 0,
                    y: editedBanner.mobileImage.crop.y || 0,
                    width: editedBanner.mobileImage.crop.width || 0,
                    height: editedBanner.mobileImage.crop.height || 0,
                },
            },
            nick: editedBanner.nick,
            title: editedBanner.title,
            description: editedBanner.description === null || editedBanner.description === undefined ? null : editedBanner.description,
            url: editedBanner.url === null || editedBanner.url === undefined ? null : editedBanner.url,
        },
    };
    const ret = await makeRequest({name: "editBanner", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                mobileImage: e.translation.mobileImage === null || e.translation.mobileImage === undefined ? null : {
                    thumb: {
                        width: e.translation.mobileImage.thumb.width || 0,
                        height: e.translation.mobileImage.thumb.height || 0,
                        url: e.translation.mobileImage.thumb.url,
                    },
                    width: e.translation.mobileImage.width || 0,
                    height: e.translation.mobileImage.height || 0,
                    url: e.translation.mobileImage.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    };
}

export async function deleteBanner(bannerId: string, progress?: (progress: number) => void): Promise<void> {
    const args = {
        bannerId: bannerId,
    };
    await makeRequest({name: "deleteBanner", args, progress});
    return undefined;
}

export async function getBedrooms(pageOffset: number, progress?: (progress: number) => void): Promise<Bedroom[]> {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({name: "getBedrooms", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        bedroomSpecifications: e.bedroomSpecifications === null || e.bedroomSpecifications === undefined ? null : e.bedroomSpecifications.map((e: any) => ({
            type: e.type,
            details: e.details,
        })),
        order: e.order === null || e.order === undefined ? null : e.order || 0,
    }));
}

export async function getBedroom(bedroomId: string, progress?: (progress: number) => void): Promise<Bedroom> {
    const args = {
        bedroomId: bedroomId,
    };
    const ret = await makeRequest({name: "getBedroom", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        bedroomSpecifications: ret.bedroomSpecifications === null || ret.bedroomSpecifications === undefined ? null : ret.bedroomSpecifications.map((e: any) => ({
            type: e.type,
            details: e.details,
        })),
        order: ret.order === null || ret.order === undefined ? null : ret.order || 0,
    };
}

export async function getAllBedrooms(hotelId: string | null, progress?: (progress: number) => void): Promise<Bedroom[]> {
    const args = {
        hotelId: hotelId === null || hotelId === undefined ? null : hotelId,
    };
    const ret = await makeRequest({name: "getAllBedrooms", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        bedroomSpecifications: e.bedroomSpecifications === null || e.bedroomSpecifications === undefined ? null : e.bedroomSpecifications.map((e: any) => ({
            type: e.type,
            details: e.details,
        })),
        order: e.order === null || e.order === undefined ? null : e.order || 0,
    }));
}

export async function createBedroom(newBedroom: NewBedroom, progress?: (progress: number) => void): Promise<Bedroom> {
    const args = {
        newBedroom: {
            bedroomSpecifications: newBedroom.bedroomSpecifications === null || newBedroom.bedroomSpecifications === undefined ? null : newBedroom.bedroomSpecifications.map(e => ({
                type: e.type,
                details: e.details,
            })),
            order: newBedroom.order === null || newBedroom.order === undefined ? null : newBedroom.order || 0,
            images: newBedroom.images.map(e => ({
                bytes: e.bytes === null || e.bytes === undefined ? null : e.bytes.toString("base64"),
                image: e.image === null || e.image === undefined ? null : {
                    thumb: {
                        width: e.image.thumb.width || 0,
                        height: e.image.thumb.height || 0,
                        url: e.image.thumb.url,
                    },
                    width: e.image.width || 0,
                    height: e.image.height || 0,
                    url: e.image.url,
                },
                crop: e.crop === null || e.crop === undefined ? null : {
                    x: e.crop.x || 0,
                    y: e.crop.y || 0,
                    width: e.crop.width || 0,
                    height: e.crop.height || 0,
                },
            })),
            nick: newBedroom.nick,
            name: newBedroom.name,
            description: newBedroom.description === null || newBedroom.description === undefined ? null : newBedroom.description,
            url: newBedroom.url === null || newBedroom.url === undefined ? null : newBedroom.url,
        },
    };
    const ret = await makeRequest({name: "createBedroom", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        bedroomSpecifications: ret.bedroomSpecifications === null || ret.bedroomSpecifications === undefined ? null : ret.bedroomSpecifications.map((e: any) => ({
            type: e.type,
            details: e.details,
        })),
        order: ret.order === null || ret.order === undefined ? null : ret.order || 0,
    };
}

export async function editBedroom(bedroomId: string, editedBedroom: EditBedroom, progress?: (progress: number) => void): Promise<Bedroom> {
    const args = {
        bedroomId: bedroomId,
        editedBedroom: {
            language: editedBedroom.language,
            bedroomSpecifications: editedBedroom.bedroomSpecifications === null || editedBedroom.bedroomSpecifications === undefined ? null : editedBedroom.bedroomSpecifications.map(e => ({
                type: e.type,
                details: e.details,
            })),
            order: editedBedroom.order === null || editedBedroom.order === undefined ? null : editedBedroom.order || 0,
            images: editedBedroom.images.map(e => ({
                bytes: e.bytes === null || e.bytes === undefined ? null : e.bytes.toString("base64"),
                image: e.image === null || e.image === undefined ? null : {
                    thumb: {
                        width: e.image.thumb.width || 0,
                        height: e.image.thumb.height || 0,
                        url: e.image.thumb.url,
                    },
                    width: e.image.width || 0,
                    height: e.image.height || 0,
                    url: e.image.url,
                },
                crop: e.crop === null || e.crop === undefined ? null : {
                    x: e.crop.x || 0,
                    y: e.crop.y || 0,
                    width: e.crop.width || 0,
                    height: e.crop.height || 0,
                },
            })),
            nick: editedBedroom.nick,
            name: editedBedroom.name,
            description: editedBedroom.description === null || editedBedroom.description === undefined ? null : editedBedroom.description,
            url: editedBedroom.url === null || editedBedroom.url === undefined ? null : editedBedroom.url,
        },
    };
    const ret = await makeRequest({name: "editBedroom", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        bedroomSpecifications: ret.bedroomSpecifications === null || ret.bedroomSpecifications === undefined ? null : ret.bedroomSpecifications.map((e: any) => ({
            type: e.type,
            details: e.details,
        })),
        order: ret.order === null || ret.order === undefined ? null : ret.order || 0,
    };
}

export async function deleteBedroom(bedroomId: string, progress?: (progress: number) => void): Promise<void> {
    const args = {
        bedroomId: bedroomId,
    };
    await makeRequest({name: "deleteBedroom", args, progress});
    return undefined;
}

export async function sendContactHotel(hotelId: string, newContact: NewContact, progress?: (progress: number) => void): Promise<void> {
    const args = {
        hotelId: hotelId,
        newContact: {
            name: newContact.name,
            email: newContact.email,
            phone: newContact.phone,
            city: newContact.city,
            subject: newContact.subject === null || newContact.subject === undefined ? null : newContact.subject,
            message: newContact.message,
        },
    };
    await makeRequest({name: "sendContactHotel", args, progress});
    return undefined;
}

export async function sendBudgetRequest(hotelId: string, newBudgetRequest: NewBudgetRequest, progress?: (progress: number) => void): Promise<void> {
    const args = {
        hotelId: hotelId,
        newBudgetRequest: {
            groupName: newBudgetRequest.groupName,
            eventType: newBudgetRequest.eventType,
            roomFormat: newBudgetRequest.roomFormat,
            date: newBudgetRequest.date === null || newBudgetRequest.date === undefined ? null : (typeof newBudgetRequest.date === "string" && (newBudgetRequest.date as any).match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? (newBudgetRequest.date as any).replace("Z", "") : newBudgetRequest.date.toISOString().replace("Z", "")),
            numberOfParticipants: newBudgetRequest.numberOfParticipants || 0,
            name: newBudgetRequest.name,
            company: newBudgetRequest.company === null || newBudgetRequest.company === undefined ? null : newBudgetRequest.company,
            phone: newBudgetRequest.phone,
            email: newBudgetRequest.email,
            message: newBudgetRequest.message === null || newBudgetRequest.message === undefined ? null : newBudgetRequest.message,
        },
    };
    await makeRequest({name: "sendBudgetRequest", args, progress});
    return undefined;
}

export async function getGallery(pageOffset: number, progress?: (progress: number) => void): Promise<Gallery[]> {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({name: "getGallery", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
            },
        })),
    }));
}

export async function getPicture(galleryId: string, progress?: (progress: number) => void): Promise<Gallery> {
    const args = {
        galleryId: galleryId,
    };
    const ret = await makeRequest({name: "getPicture", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
            },
        })),
    };
}

export async function getAllGalleryInfo(hotelId: string, progress?: (progress: number) => void): Promise<Gallery[]> {
    const args = {
        hotelId: hotelId,
    };
    const ret = await makeRequest({name: "getAllGalleryInfo", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
            },
        })),
    }));
}

export async function createGallery(newGallery: NewGallery, progress?: (progress: number) => void): Promise<Gallery> {
    const args = {
        newGallery: {
            image: {
                bytes: newGallery.image.bytes === null || newGallery.image.bytes === undefined ? null : newGallery.image.bytes.toString("base64"),
                image: newGallery.image.image === null || newGallery.image.image === undefined ? null : {
                    thumb: {
                        width: newGallery.image.image.thumb.width || 0,
                        height: newGallery.image.image.thumb.height || 0,
                        url: newGallery.image.image.thumb.url,
                    },
                    width: newGallery.image.image.width || 0,
                    height: newGallery.image.image.height || 0,
                    url: newGallery.image.image.url,
                },
                crop: newGallery.image.crop === null || newGallery.image.crop === undefined ? null : {
                    x: newGallery.image.crop.x || 0,
                    y: newGallery.image.crop.y || 0,
                    width: newGallery.image.crop.width || 0,
                    height: newGallery.image.crop.height || 0,
                },
            },
            nick: newGallery.nick,
            title: newGallery.title,
            description: newGallery.description === null || newGallery.description === undefined ? null : newGallery.description,
        },
    };
    const ret = await makeRequest({name: "createGallery", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
            },
        })),
    };
}

export async function editGallery(gallery: string, editedGallery: EditGallery, progress?: (progress: number) => void): Promise<Gallery> {
    const args = {
        gallery: gallery,
        editedGallery: {
            language: editedGallery.language,
            image: {
                bytes: editedGallery.image.bytes === null || editedGallery.image.bytes === undefined ? null : editedGallery.image.bytes.toString("base64"),
                image: editedGallery.image.image === null || editedGallery.image.image === undefined ? null : {
                    thumb: {
                        width: editedGallery.image.image.thumb.width || 0,
                        height: editedGallery.image.image.thumb.height || 0,
                        url: editedGallery.image.image.thumb.url,
                    },
                    width: editedGallery.image.image.width || 0,
                    height: editedGallery.image.image.height || 0,
                    url: editedGallery.image.image.url,
                },
                crop: editedGallery.image.crop === null || editedGallery.image.crop === undefined ? null : {
                    x: editedGallery.image.crop.x || 0,
                    y: editedGallery.image.crop.y || 0,
                    width: editedGallery.image.crop.width || 0,
                    height: editedGallery.image.crop.height || 0,
                },
            },
            nick: editedGallery.nick,
            title: editedGallery.title,
            description: editedGallery.description === null || editedGallery.description === undefined ? null : editedGallery.description,
        },
    };
    const ret = await makeRequest({name: "editGallery", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                title: e.translation.title,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
            },
        })),
    };
}

export async function deleteGallery(gallery: string, progress?: (progress: number) => void): Promise<void> {
    const args = {
        gallery: gallery,
    };
    await makeRequest({name: "deleteGallery", args, progress});
    return undefined;
}

export async function getGastroPlaces(pageOffset: number, progress?: (progress: number) => void): Promise<GastroPlace[]> {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({name: "getGastroPlaces", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
                type: e.translation.type,
            },
        })),
    }));
}

export async function getGastroPlace(gastroPlaceId: string, progress?: (progress: number) => void): Promise<GastroPlace> {
    const args = {
        gastroPlaceId: gastroPlaceId,
    };
    const ret = await makeRequest({name: "getGastroPlace", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
                type: e.translation.type,
            },
        })),
    };
}

export async function getAllGastroPlaces(hotelId: string, progress?: (progress: number) => void): Promise<GastroPlace[]> {
    const args = {
        hotelId: hotelId,
    };
    const ret = await makeRequest({name: "getAllGastroPlaces", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
                type: e.translation.type,
            },
        })),
    }));
}

export async function createGastroPlace(newGastroPlace: NewGastroPlace, progress?: (progress: number) => void): Promise<GastroPlace> {
    const args = {
        newGastroPlace: {
            images: newGastroPlace.images.map(e => ({
                bytes: e.bytes === null || e.bytes === undefined ? null : e.bytes.toString("base64"),
                image: e.image === null || e.image === undefined ? null : {
                    thumb: {
                        width: e.image.thumb.width || 0,
                        height: e.image.thumb.height || 0,
                        url: e.image.thumb.url,
                    },
                    width: e.image.width || 0,
                    height: e.image.height || 0,
                    url: e.image.url,
                },
                crop: e.crop === null || e.crop === undefined ? null : {
                    x: e.crop.x || 0,
                    y: e.crop.y || 0,
                    width: e.crop.width || 0,
                    height: e.crop.height || 0,
                },
            })),
            nick: newGastroPlace.nick,
            name: newGastroPlace.name,
            description: newGastroPlace.description,
            url: newGastroPlace.url === null || newGastroPlace.url === undefined ? null : newGastroPlace.url,
            type: newGastroPlace.type,
        },
    };
    const ret = await makeRequest({name: "createGastroPlace", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
                type: e.translation.type,
            },
        })),
    };
}

export async function editGastroPlace(gastroPlaceId: string, editedGastroPlace: EditGastroPlace, progress?: (progress: number) => void): Promise<GastroPlace> {
    const args = {
        gastroPlaceId: gastroPlaceId,
        editedGastroPlace: {
            language: editedGastroPlace.language,
            images: editedGastroPlace.images.map(e => ({
                bytes: e.bytes === null || e.bytes === undefined ? null : e.bytes.toString("base64"),
                image: e.image === null || e.image === undefined ? null : {
                    thumb: {
                        width: e.image.thumb.width || 0,
                        height: e.image.thumb.height || 0,
                        url: e.image.thumb.url,
                    },
                    width: e.image.width || 0,
                    height: e.image.height || 0,
                    url: e.image.url,
                },
                crop: e.crop === null || e.crop === undefined ? null : {
                    x: e.crop.x || 0,
                    y: e.crop.y || 0,
                    width: e.crop.width || 0,
                    height: e.crop.height || 0,
                },
            })),
            nick: editedGastroPlace.nick,
            name: editedGastroPlace.name,
            description: editedGastroPlace.description,
            url: editedGastroPlace.url === null || editedGastroPlace.url === undefined ? null : editedGastroPlace.url,
            type: editedGastroPlace.type,
        },
    };
    const ret = await makeRequest({name: "editGastroPlace", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
                type: e.translation.type,
            },
        })),
    };
}

export async function deleteGastroPlace(gastroPlaceId: string, progress?: (progress: number) => void): Promise<void> {
    const args = {
        gastroPlaceId: gastroPlaceId,
    };
    await makeRequest({name: "deleteGastroPlace", args, progress});
    return undefined;
}

export async function getAddressFromCep(cep: string, progress?: (progress: number) => void): Promise<Address> {
    const args = {
        cep: cep,
    };
    const ret = await makeRequest({name: "getAddressFromCep", args, progress});
    return {
        cep: ret.cep,
        number: ret.number,
        street: ret.street,
        neighborhood: ret.neighborhood,
        city: ret.city,
        cityId: ret.cityId === null || ret.cityId === undefined ? null : ret.cityId,
        state: ret.state,
        uf: ret.uf,
        latLng: {
            lat: ret.latLng.lat,
            lng: ret.latLng.lng,
        },
    };
}

export async function editHotel(editedHotel: EditHotel, progress?: (progress: number) => void): Promise<Hotel> {
    const args = {
        editedHotel: {
            language: editedHotel.language,
            image: {
                bytes: editedHotel.image.bytes === null || editedHotel.image.bytes === undefined ? null : editedHotel.image.bytes.toString("base64"),
                image: editedHotel.image.image === null || editedHotel.image.image === undefined ? null : {
                    thumb: {
                        width: editedHotel.image.image.thumb.width || 0,
                        height: editedHotel.image.image.thumb.height || 0,
                        url: editedHotel.image.image.thumb.url,
                    },
                    width: editedHotel.image.image.width || 0,
                    height: editedHotel.image.image.height || 0,
                    url: editedHotel.image.image.url,
                },
                crop: editedHotel.image.crop === null || editedHotel.image.crop === undefined ? null : {
                    x: editedHotel.image.crop.x || 0,
                    y: editedHotel.image.crop.y || 0,
                    width: editedHotel.image.crop.width || 0,
                    height: editedHotel.image.crop.height || 0,
                },
            },
            logos: {
                horizontal: {
                    bytes: editedHotel.logos.horizontal.bytes === null || editedHotel.logos.horizontal.bytes === undefined ? null : editedHotel.logos.horizontal.bytes.toString("base64"),
                    image: editedHotel.logos.horizontal.image === null || editedHotel.logos.horizontal.image === undefined ? null : {
                        thumb: {
                            width: editedHotel.logos.horizontal.image.thumb.width || 0,
                            height: editedHotel.logos.horizontal.image.thumb.height || 0,
                            url: editedHotel.logos.horizontal.image.thumb.url,
                        },
                        width: editedHotel.logos.horizontal.image.width || 0,
                        height: editedHotel.logos.horizontal.image.height || 0,
                        url: editedHotel.logos.horizontal.image.url,
                    },
                    crop: editedHotel.logos.horizontal.crop === null || editedHotel.logos.horizontal.crop === undefined ? null : {
                        x: editedHotel.logos.horizontal.crop.x || 0,
                        y: editedHotel.logos.horizontal.crop.y || 0,
                        width: editedHotel.logos.horizontal.crop.width || 0,
                        height: editedHotel.logos.horizontal.crop.height || 0,
                    },
                },
                squared: {
                    bytes: editedHotel.logos.squared.bytes === null || editedHotel.logos.squared.bytes === undefined ? null : editedHotel.logos.squared.bytes.toString("base64"),
                    image: editedHotel.logos.squared.image === null || editedHotel.logos.squared.image === undefined ? null : {
                        thumb: {
                            width: editedHotel.logos.squared.image.thumb.width || 0,
                            height: editedHotel.logos.squared.image.thumb.height || 0,
                            url: editedHotel.logos.squared.image.thumb.url,
                        },
                        width: editedHotel.logos.squared.image.width || 0,
                        height: editedHotel.logos.squared.image.height || 0,
                        url: editedHotel.logos.squared.image.url,
                    },
                    crop: editedHotel.logos.squared.crop === null || editedHotel.logos.squared.crop === undefined ? null : {
                        x: editedHotel.logos.squared.crop.x || 0,
                        y: editedHotel.logos.squared.crop.y || 0,
                        width: editedHotel.logos.squared.crop.width || 0,
                        height: editedHotel.logos.squared.crop.height || 0,
                    },
                },
                white: editedHotel.logos.white === null || editedHotel.logos.white === undefined ? null : {
                    bytes: editedHotel.logos.white.bytes === null || editedHotel.logos.white.bytes === undefined ? null : editedHotel.logos.white.bytes.toString("base64"),
                    image: editedHotel.logos.white.image === null || editedHotel.logos.white.image === undefined ? null : {
                        thumb: {
                            width: editedHotel.logos.white.image.thumb.width || 0,
                            height: editedHotel.logos.white.image.thumb.height || 0,
                            url: editedHotel.logos.white.image.thumb.url,
                        },
                        width: editedHotel.logos.white.image.width || 0,
                        height: editedHotel.logos.white.image.height || 0,
                        url: editedHotel.logos.white.image.url,
                    },
                    crop: editedHotel.logos.white.crop === null || editedHotel.logos.white.crop === undefined ? null : {
                        x: editedHotel.logos.white.crop.x || 0,
                        y: editedHotel.logos.white.crop.y || 0,
                        width: editedHotel.logos.white.crop.width || 0,
                        height: editedHotel.logos.white.crop.height || 0,
                    },
                },
            },
            nick: editedHotel.nick,
            name: editedHotel.name,
            slogan: editedHotel.slogan === null || editedHotel.slogan === undefined ? null : editedHotel.slogan,
            description: editedHotel.description,
            roomsDescription: editedHotel.roomsDescription === null || editedHotel.roomsDescription === undefined ? null : editedHotel.roomsDescription,
            colors: {
                primary: editedHotel.colors.primary,
                secondary: editedHotel.colors.secondary,
                tertiary: editedHotel.colors.tertiary === null || editedHotel.colors.tertiary === undefined ? null : editedHotel.colors.tertiary,
                background: editedHotel.colors.background,
                textPrimary: editedHotel.colors.textPrimary,
                textSecondary: editedHotel.colors.textSecondary === null || editedHotel.colors.textSecondary === undefined ? null : editedHotel.colors.textSecondary,
                textTertiary: editedHotel.colors.textTertiary === null || editedHotel.colors.textTertiary === undefined ? null : editedHotel.colors.textTertiary,
            },
            videoUrl: editedHotel.videoUrl,
            email: editedHotel.email,
            phone: editedHotel.phone,
            socialMedia: {
                instagram: editedHotel.socialMedia.instagram === null || editedHotel.socialMedia.instagram === undefined ? null : editedHotel.socialMedia.instagram,
                facebook: editedHotel.socialMedia.facebook === null || editedHotel.socialMedia.facebook === undefined ? null : editedHotel.socialMedia.facebook,
                linkedin: editedHotel.socialMedia.linkedin === null || editedHotel.socialMedia.linkedin === undefined ? null : editedHotel.socialMedia.linkedin,
            },
            address: {
                cep: editedHotel.address.cep,
                number: editedHotel.address.number,
                street: editedHotel.address.street,
                neighborhood: editedHotel.address.neighborhood,
                city: editedHotel.address.city,
                cityId: editedHotel.address.cityId === null || editedHotel.address.cityId === undefined ? null : editedHotel.address.cityId,
                state: editedHotel.address.state,
                uf: editedHotel.address.uf,
                latLng: {
                    lat: editedHotel.address.latLng.lat,
                    lng: editedHotel.address.latLng.lng,
                },
            },
            reserveDisponibility: {
                start: editedHotel.reserveDisponibility.start || 0,
                end: editedHotel.reserveDisponibility.end || 0,
            },
            omnibeesId: editedHotel.omnibeesId,
            metaTags: editedHotel.metaTags.map(e => e),
        },
    };
    const ret = await makeRequest({name: "editHotel", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                name: e.translation.name,
                slogan: e.translation.slogan === null || e.translation.slogan === undefined ? null : e.translation.slogan,
                description: e.translation.description,
                roomsDescription: e.translation.roomsDescription === null || e.translation.roomsDescription === undefined ? null : e.translation.roomsDescription,
            },
        })),
        colors: {
            primary: ret.colors.primary,
            secondary: ret.colors.secondary,
            tertiary: ret.colors.tertiary === null || ret.colors.tertiary === undefined ? null : ret.colors.tertiary,
            background: ret.colors.background,
            textPrimary: ret.colors.textPrimary,
            textSecondary: ret.colors.textSecondary === null || ret.colors.textSecondary === undefined ? null : ret.colors.textSecondary,
            textTertiary: ret.colors.textTertiary === null || ret.colors.textTertiary === undefined ? null : ret.colors.textTertiary,
        },
        logos: {
            horizontal: {
                thumb: {
                    width: ret.logos.horizontal.thumb.width || 0,
                    height: ret.logos.horizontal.thumb.height || 0,
                    url: ret.logos.horizontal.thumb.url,
                },
                width: ret.logos.horizontal.width || 0,
                height: ret.logos.horizontal.height || 0,
                url: ret.logos.horizontal.url,
            },
            squared: {
                thumb: {
                    width: ret.logos.squared.thumb.width || 0,
                    height: ret.logos.squared.thumb.height || 0,
                    url: ret.logos.squared.thumb.url,
                },
                width: ret.logos.squared.width || 0,
                height: ret.logos.squared.height || 0,
                url: ret.logos.squared.url,
            },
            white: ret.logos.white === null || ret.logos.white === undefined ? null : {
                thumb: {
                    width: ret.logos.white.thumb.width || 0,
                    height: ret.logos.white.thumb.height || 0,
                    url: ret.logos.white.thumb.url,
                },
                width: ret.logos.white.width || 0,
                height: ret.logos.white.height || 0,
                url: ret.logos.white.url,
            },
        },
        videoUrl: ret.videoUrl,
        email: ret.email,
        phone: ret.phone,
        socialMedia: {
            instagram: ret.socialMedia.instagram === null || ret.socialMedia.instagram === undefined ? null : ret.socialMedia.instagram,
            facebook: ret.socialMedia.facebook === null || ret.socialMedia.facebook === undefined ? null : ret.socialMedia.facebook,
            linkedin: ret.socialMedia.linkedin === null || ret.socialMedia.linkedin === undefined ? null : ret.socialMedia.linkedin,
        },
        address: {
            cep: ret.address.cep,
            number: ret.address.number,
            street: ret.address.street,
            neighborhood: ret.address.neighborhood,
            city: ret.address.city,
            cityId: ret.address.cityId === null || ret.address.cityId === undefined ? null : ret.address.cityId,
            state: ret.address.state,
            uf: ret.address.uf,
            latLng: {
                lat: ret.address.latLng.lat,
                lng: ret.address.latLng.lng,
            },
        },
        reserveDisponibility: {
            start: ret.reserveDisponibility.start || 0,
            end: ret.reserveDisponibility.end || 0,
        },
        omnibeesId: ret.omnibeesId,
        metaTags: ret.metaTags.map((e: any) => e),
    };
}

export async function getAdminUserHotel(progress?: (progress: number) => void): Promise<Hotel> {
    const ret = await makeRequest({name: "getAdminUserHotel", args: {}, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                name: e.translation.name,
                slogan: e.translation.slogan === null || e.translation.slogan === undefined ? null : e.translation.slogan,
                description: e.translation.description,
                roomsDescription: e.translation.roomsDescription === null || e.translation.roomsDescription === undefined ? null : e.translation.roomsDescription,
            },
        })),
        colors: {
            primary: ret.colors.primary,
            secondary: ret.colors.secondary,
            tertiary: ret.colors.tertiary === null || ret.colors.tertiary === undefined ? null : ret.colors.tertiary,
            background: ret.colors.background,
            textPrimary: ret.colors.textPrimary,
            textSecondary: ret.colors.textSecondary === null || ret.colors.textSecondary === undefined ? null : ret.colors.textSecondary,
            textTertiary: ret.colors.textTertiary === null || ret.colors.textTertiary === undefined ? null : ret.colors.textTertiary,
        },
        logos: {
            horizontal: {
                thumb: {
                    width: ret.logos.horizontal.thumb.width || 0,
                    height: ret.logos.horizontal.thumb.height || 0,
                    url: ret.logos.horizontal.thumb.url,
                },
                width: ret.logos.horizontal.width || 0,
                height: ret.logos.horizontal.height || 0,
                url: ret.logos.horizontal.url,
            },
            squared: {
                thumb: {
                    width: ret.logos.squared.thumb.width || 0,
                    height: ret.logos.squared.thumb.height || 0,
                    url: ret.logos.squared.thumb.url,
                },
                width: ret.logos.squared.width || 0,
                height: ret.logos.squared.height || 0,
                url: ret.logos.squared.url,
            },
            white: ret.logos.white === null || ret.logos.white === undefined ? null : {
                thumb: {
                    width: ret.logos.white.thumb.width || 0,
                    height: ret.logos.white.thumb.height || 0,
                    url: ret.logos.white.thumb.url,
                },
                width: ret.logos.white.width || 0,
                height: ret.logos.white.height || 0,
                url: ret.logos.white.url,
            },
        },
        videoUrl: ret.videoUrl,
        email: ret.email,
        phone: ret.phone,
        socialMedia: {
            instagram: ret.socialMedia.instagram === null || ret.socialMedia.instagram === undefined ? null : ret.socialMedia.instagram,
            facebook: ret.socialMedia.facebook === null || ret.socialMedia.facebook === undefined ? null : ret.socialMedia.facebook,
            linkedin: ret.socialMedia.linkedin === null || ret.socialMedia.linkedin === undefined ? null : ret.socialMedia.linkedin,
        },
        address: {
            cep: ret.address.cep,
            number: ret.address.number,
            street: ret.address.street,
            neighborhood: ret.address.neighborhood,
            city: ret.address.city,
            cityId: ret.address.cityId === null || ret.address.cityId === undefined ? null : ret.address.cityId,
            state: ret.address.state,
            uf: ret.address.uf,
            latLng: {
                lat: ret.address.latLng.lat,
                lng: ret.address.latLng.lng,
            },
        },
        reserveDisponibility: {
            start: ret.reserveDisponibility.start || 0,
            end: ret.reserveDisponibility.end || 0,
        },
        omnibeesId: ret.omnibeesId,
        metaTags: ret.metaTags.map((e: any) => e),
    };
}

export async function getOffers(pageOffset: number, progress?: (progress: number) => void): Promise<Offer[]> {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({name: "getOffers", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                descriptionHtml: e.translation.descriptionHtml === null || e.translation.descriptionHtml === undefined ? null : e.translation.descriptionHtml,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    }));
}

export async function getOffer(offerId: string, progress?: (progress: number) => void): Promise<Offer> {
    const args = {
        offerId: offerId,
    };
    const ret = await makeRequest({name: "getOffer", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                descriptionHtml: e.translation.descriptionHtml === null || e.translation.descriptionHtml === undefined ? null : e.translation.descriptionHtml,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    };
}

export async function getAllOffers(hotelId: string, progress?: (progress: number) => void): Promise<Offer[]> {
    const args = {
        hotelId: hotelId,
    };
    const ret = await makeRequest({name: "getAllOffers", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                descriptionHtml: e.translation.descriptionHtml === null || e.translation.descriptionHtml === undefined ? null : e.translation.descriptionHtml,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    }));
}

export async function createOffer(newOffer: NewOffer, progress?: (progress: number) => void): Promise<Offer> {
    const args = {
        newOffer: {
            image: {
                bytes: newOffer.image.bytes === null || newOffer.image.bytes === undefined ? null : newOffer.image.bytes.toString("base64"),
                image: newOffer.image.image === null || newOffer.image.image === undefined ? null : {
                    thumb: {
                        width: newOffer.image.image.thumb.width || 0,
                        height: newOffer.image.image.thumb.height || 0,
                        url: newOffer.image.image.thumb.url,
                    },
                    width: newOffer.image.image.width || 0,
                    height: newOffer.image.image.height || 0,
                    url: newOffer.image.image.url,
                },
                crop: newOffer.image.crop === null || newOffer.image.crop === undefined ? null : {
                    x: newOffer.image.crop.x || 0,
                    y: newOffer.image.crop.y || 0,
                    width: newOffer.image.crop.width || 0,
                    height: newOffer.image.crop.height || 0,
                },
            },
            nick: newOffer.nick,
            name: newOffer.name,
            description: newOffer.description === null || newOffer.description === undefined ? null : newOffer.description,
            descriptionHtml: newOffer.descriptionHtml === null || newOffer.descriptionHtml === undefined ? null : newOffer.descriptionHtml,
            url: newOffer.url === null || newOffer.url === undefined ? null : newOffer.url,
        },
    };
    const ret = await makeRequest({name: "createOffer", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                descriptionHtml: e.translation.descriptionHtml === null || e.translation.descriptionHtml === undefined ? null : e.translation.descriptionHtml,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    };
}

export async function editOffer(offerId: string, editedOffer: EditOffer, progress?: (progress: number) => void): Promise<Offer> {
    const args = {
        offerId: offerId,
        editedOffer: {
            language: editedOffer.language,
            image: {
                bytes: editedOffer.image.bytes === null || editedOffer.image.bytes === undefined ? null : editedOffer.image.bytes.toString("base64"),
                image: editedOffer.image.image === null || editedOffer.image.image === undefined ? null : {
                    thumb: {
                        width: editedOffer.image.image.thumb.width || 0,
                        height: editedOffer.image.image.thumb.height || 0,
                        url: editedOffer.image.image.thumb.url,
                    },
                    width: editedOffer.image.image.width || 0,
                    height: editedOffer.image.image.height || 0,
                    url: editedOffer.image.image.url,
                },
                crop: editedOffer.image.crop === null || editedOffer.image.crop === undefined ? null : {
                    x: editedOffer.image.crop.x || 0,
                    y: editedOffer.image.crop.y || 0,
                    width: editedOffer.image.crop.width || 0,
                    height: editedOffer.image.crop.height || 0,
                },
            },
            nick: editedOffer.nick,
            name: editedOffer.name,
            description: editedOffer.description === null || editedOffer.description === undefined ? null : editedOffer.description,
            descriptionHtml: editedOffer.descriptionHtml === null || editedOffer.descriptionHtml === undefined ? null : editedOffer.descriptionHtml,
            url: editedOffer.url === null || editedOffer.url === undefined ? null : editedOffer.url,
        },
    };
    const ret = await makeRequest({name: "editOffer", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                image: {
                    thumb: {
                        width: e.translation.image.thumb.width || 0,
                        height: e.translation.image.thumb.height || 0,
                        url: e.translation.image.thumb.url,
                    },
                    width: e.translation.image.width || 0,
                    height: e.translation.image.height || 0,
                    url: e.translation.image.url,
                },
                nick: e.translation.nick,
                name: e.translation.name,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                descriptionHtml: e.translation.descriptionHtml === null || e.translation.descriptionHtml === undefined ? null : e.translation.descriptionHtml,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
    };
}

export async function deleteOffer(offerId: string, progress?: (progress: number) => void): Promise<void> {
    const args = {
        offerId: offerId,
    };
    await makeRequest({name: "deleteOffer", args, progress});
    return undefined;
}

export async function getRooms(pageOffset: number, progress?: (progress: number) => void): Promise<Room[]> {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({name: "getRooms", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                layouts: e.translation.layouts.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                name: e.translation.name,
                nick: e.translation.nick,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        order: e.order === null || e.order === undefined ? null : e.order || 0,
    }));
}

export async function getRoom(roomId: string, progress?: (progress: number) => void): Promise<Room> {
    const args = {
        roomId: roomId,
    };
    const ret = await makeRequest({name: "getRoom", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                layouts: e.translation.layouts.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                name: e.translation.name,
                nick: e.translation.nick,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        order: ret.order === null || ret.order === undefined ? null : ret.order || 0,
    };
}

export async function getAllRooms(hotelId: string | null, progress?: (progress: number) => void): Promise<Room[]> {
    const args = {
        hotelId: hotelId === null || hotelId === undefined ? null : hotelId,
    };
    const ret = await makeRequest({name: "getAllRooms", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        languages: e.languages.map((e: any) => ({
            language: e.language,
            translation: {
                layouts: e.translation.layouts.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                name: e.translation.name,
                nick: e.translation.nick,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        order: e.order === null || e.order === undefined ? null : e.order || 0,
    }));
}

export async function createRoom(newRoom: NewRoom, progress?: (progress: number) => void): Promise<Room> {
    const args = {
        newRoom: {
            order: newRoom.order === null || newRoom.order === undefined ? null : newRoom.order || 0,
            layouts: newRoom.layouts.map(e => ({
                bytes: e.bytes === null || e.bytes === undefined ? null : e.bytes.toString("base64"),
                image: e.image === null || e.image === undefined ? null : {
                    thumb: {
                        width: e.image.thumb.width || 0,
                        height: e.image.thumb.height || 0,
                        url: e.image.thumb.url,
                    },
                    width: e.image.width || 0,
                    height: e.image.height || 0,
                    url: e.image.url,
                },
                crop: e.crop === null || e.crop === undefined ? null : {
                    x: e.crop.x || 0,
                    y: e.crop.y || 0,
                    width: e.crop.width || 0,
                    height: e.crop.height || 0,
                },
            })),
            images: newRoom.images.map(e => ({
                bytes: e.bytes === null || e.bytes === undefined ? null : e.bytes.toString("base64"),
                image: e.image === null || e.image === undefined ? null : {
                    thumb: {
                        width: e.image.thumb.width || 0,
                        height: e.image.thumb.height || 0,
                        url: e.image.thumb.url,
                    },
                    width: e.image.width || 0,
                    height: e.image.height || 0,
                    url: e.image.url,
                },
                crop: e.crop === null || e.crop === undefined ? null : {
                    x: e.crop.x || 0,
                    y: e.crop.y || 0,
                    width: e.crop.width || 0,
                    height: e.crop.height || 0,
                },
            })),
            name: newRoom.name,
            nick: newRoom.nick,
            description: newRoom.description === null || newRoom.description === undefined ? null : newRoom.description,
            url: newRoom.url === null || newRoom.url === undefined ? null : newRoom.url,
        },
    };
    const ret = await makeRequest({name: "createRoom", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                layouts: e.translation.layouts.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                name: e.translation.name,
                nick: e.translation.nick,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        order: ret.order === null || ret.order === undefined ? null : ret.order || 0,
    };
}

export async function editRoom(roomId: string, editedRoom: EditRoom, progress?: (progress: number) => void): Promise<Room> {
    const args = {
        roomId: roomId,
        editedRoom: {
            language: editedRoom.language,
            order: editedRoom.order === null || editedRoom.order === undefined ? null : editedRoom.order || 0,
            layouts: editedRoom.layouts.map(e => ({
                bytes: e.bytes === null || e.bytes === undefined ? null : e.bytes.toString("base64"),
                image: e.image === null || e.image === undefined ? null : {
                    thumb: {
                        width: e.image.thumb.width || 0,
                        height: e.image.thumb.height || 0,
                        url: e.image.thumb.url,
                    },
                    width: e.image.width || 0,
                    height: e.image.height || 0,
                    url: e.image.url,
                },
                crop: e.crop === null || e.crop === undefined ? null : {
                    x: e.crop.x || 0,
                    y: e.crop.y || 0,
                    width: e.crop.width || 0,
                    height: e.crop.height || 0,
                },
            })),
            images: editedRoom.images.map(e => ({
                bytes: e.bytes === null || e.bytes === undefined ? null : e.bytes.toString("base64"),
                image: e.image === null || e.image === undefined ? null : {
                    thumb: {
                        width: e.image.thumb.width || 0,
                        height: e.image.thumb.height || 0,
                        url: e.image.thumb.url,
                    },
                    width: e.image.width || 0,
                    height: e.image.height || 0,
                    url: e.image.url,
                },
                crop: e.crop === null || e.crop === undefined ? null : {
                    x: e.crop.x || 0,
                    y: e.crop.y || 0,
                    width: e.crop.width || 0,
                    height: e.crop.height || 0,
                },
            })),
            name: editedRoom.name,
            nick: editedRoom.nick,
            description: editedRoom.description === null || editedRoom.description === undefined ? null : editedRoom.description,
            url: editedRoom.url === null || editedRoom.url === undefined ? null : editedRoom.url,
        },
    };
    const ret = await makeRequest({name: "editRoom", args, progress});
    return {
        id: ret.id,
        languages: ret.languages.map((e: any) => ({
            language: e.language,
            translation: {
                layouts: e.translation.layouts.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                images: e.translation.images.map((e: any) => ({
                    thumb: {
                        width: e.thumb.width || 0,
                        height: e.thumb.height || 0,
                        url: e.thumb.url,
                    },
                    width: e.width || 0,
                    height: e.height || 0,
                    url: e.url,
                })),
                name: e.translation.name,
                nick: e.translation.nick,
                description: e.translation.description === null || e.translation.description === undefined ? null : e.translation.description,
                url: e.translation.url === null || e.translation.url === undefined ? null : e.translation.url,
            },
        })),
        order: ret.order === null || ret.order === undefined ? null : ret.order || 0,
    };
}

export async function deleteRoom(roomId: string, progress?: (progress: number) => void): Promise<void> {
    const args = {
        roomId: roomId,
    };
    await makeRequest({name: "deleteRoom", args, progress});
    return undefined;
}

export async function getQuestionSections(progress?: (progress: number) => void): Promise<QuestionSection[]> {
    const ret = await makeRequest({name: "getQuestionSections", args: {}, progress});
    return ret.map((e: any) => ({
        id: e.id,
        title: e.title,
        questions: e.questions.map((e: any) => ({
            id: e.id,
            title: e.title,
        })),
    }));
}

export async function getSurveys(pageOffset: number, progress?: (progress: number) => void): Promise<Survey[]> {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({name: "getSurveys", args, progress});
    return ret.map((e: any) => ({
        id: e.id,
        answerSections: e.answerSections.map((e: any) => ({
            title: e.title,
            answers: e.answers.map((e: any) => ({
                rate: e.rate || 0,
                comment: e.comment,
                question: {
                    id: e.question.id,
                    title: e.question.title,
                },
            })),
        })),
        createdAt: new Date(e.createdAt + "Z"),
        name: e.name,
        email: e.email,
        phone: e.phone,
        nps: e.nps || 0,
        comment: e.comment,
        metaData: e.metaData.map((e: any) => ({
            tag: e.tag,
            value: e.value,
        })),
    }));
}

export async function getSurvey(surveyId: string, progress?: (progress: number) => void): Promise<Survey> {
    const args = {
        surveyId: surveyId,
    };
    const ret = await makeRequest({name: "getSurvey", args, progress});
    return {
        id: ret.id,
        answerSections: ret.answerSections.map((e: any) => ({
            title: e.title,
            answers: e.answers.map((e: any) => ({
                rate: e.rate || 0,
                comment: e.comment,
                question: {
                    id: e.question.id,
                    title: e.question.title,
                },
            })),
        })),
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        phone: ret.phone,
        nps: ret.nps || 0,
        comment: ret.comment,
        metaData: ret.metaData.map((e: any) => ({
            tag: e.tag,
            value: e.value,
        })),
    };
}

export async function getStats(progress?: (progress: number) => void): Promise<SurveyStats> {
    const ret = await makeRequest({name: "getStats", args: {}, progress});
    return {
        averageNps: ret.averageNps,
        averageRate: ret.averageRate,
        questionStatsSections: ret.questionStatsSections.map((e: any) => ({
            title: e.title,
            questionStats: e.questionStats.map((e: any) => ({
                question: {
                    id: e.question.id,
                    title: e.question.title,
                },
                averageRate: e.averageRate,
            })),
        })),
    };
}

export async function ping(progress?: (progress: number) => void): Promise<string> {
    const ret = await makeRequest({name: "ping", args: {}, progress});
    return ret;
}

export async function setPushToken(token: string, progress?: (progress: number) => void): Promise<void> {
    const args = {
        token: token,
    };
    await makeRequest({name: "setPushToken", args, progress});
    return undefined;
}

//////////////////////////////////////////////////////

let fallbackDeviceId: string | null = null;

function setDeviceId(deviceId: string): void {
    fallbackDeviceId = deviceId;
    try {
        localStorage.setItem("deviceId", deviceId);
    } catch (e) {}
}

function getDeviceId(): string | null {
    try {
        return localStorage.getItem("deviceId") || fallbackDeviceId;
    } catch (e) {}

    return fallbackDeviceId;
}

async function device(): Promise<any> {
    const parser = new UAParser();
    parser.setUA(navigator.userAgent);
    const agent = parser.getResult();
    const me = document.currentScript as HTMLScriptElement;
    const device: any = {
            type: "web",
            platform: {
                browser: agent.browser.name,
                browserVersion: agent.browser.version,
                os: agent.os.name,
                osVersion: agent.os.version,
            },
            screen: {
                width: screen.width,
                height: screen.height,
            },
            version: me ? me.src : "",
            language: navigator.language,
    };

    const deviceId = getDeviceId();
    if (deviceId)
        device.id = deviceId;

    return device;
}

function randomBytesHex(len: number): string {
    let hex = "";
    for (let i = 0; i < 2 * len; ++i) {
        hex += "0123456789abcdef"[Math.floor(Math.random() * 16)];
    }

    return hex;
}

export interface ListenerTypes {
    fail: (e: Error, name: string, args: any) => void;
    fatal: (e: Error, name: string, args: any) => void;
    success: (res: string, name: string, args: any) => void;
}

// tslint:disable-next-line: ban-types
type HookArray = Function[];
export type Listenables = keyof ListenerTypes;
export type ListenersDict = { [k in Listenables]: Array<ListenerTypes[k]> };

const listenersDict: ListenersDict = {
    fail: [],
    fatal: [],
    success: [],
};

export function addEventListener(listenable: Listenables, hook: ListenerTypes[typeof listenable]): void {
    const listeners: HookArray = listenersDict[listenable];
    listeners.push(hook);
}

export function removeEventListener(listenable: Listenables, hook: ListenerTypes[typeof listenable]): void {
    const listeners: HookArray = listenersDict[listenable];
    listenersDict[listenable] = listeners.filter((h) => h !== hook) as any;
}

async function makeRequest({name, args, progress}: {name: string, args: any, progress?: (progress: number) => void}): Promise<any> {
    const deviceData = await device();
    return new Promise<any>((resolve, reject) => {
        const req = new XMLHttpRequest();
        req.open(
            "POST",
            `${baseUrl.startsWith("http") || baseUrl.startsWith("localhost") ?
                "" :
                "https://"
            }${baseUrl}/${name}`,
        );

        const body = {
            id: randomBytesHex(8),
            device: deviceData,
            name: name,
            args: args,
        };

        function roughSizeOfObject(object: any): number {
            const objectList: any = [];
            const stack: any = [ object ];
            let bytes = 0;

            while (stack.length) {
                const value = stack.pop();
                if (typeof value === "boolean") {
                    bytes += 4;
                } else if (typeof value === "string") {
                    bytes += value.length * 2;
                } else if (typeof value === "number") {
                    bytes += 8;
                } else if (
                    typeof value === "object"
                    && objectList.indexOf(value) === -1
                ) {
                    objectList.push(value);
                    for (const i in value) {
                        stack.push(value[i]);
                    }
                }
            }

            return bytes;
        }

        req.upload.onprogress = (event: ProgressEvent) => {
            if (event.lengthComputable && progress) {
                progress(Math.ceil(((event.loaded) / event.total) * 100));
            }
        };

        req.onreadystatechange = () => {
            if (req.readyState !== 4) return;
            try {
                const response = JSON.parse(req.responseText);

                try {
                    setDeviceId(response.deviceId);

                    if (response.ok) {
                        resolve(response.result);
                        listenersDict["success"].forEach((hook) => hook(response.result, name, args));
                    } else {
                        const error = typeof response.error === "object" ?
                            response.error :
                            { type: "Fatal", message: response.toString() };

                        reject(error);

                        listenersDict["fail"].forEach((hook) => hook(error, name, args));
                    }
                } catch (e) {
                    console.error(e);
                    reject({type: "Fatal", message: `[${name}] ${e.toString()}`});

                    listenersDict["fatal"].forEach((hook) => hook(e, name, args));
                }
            } catch (e) {
                console.error(e);
                reject({ type: "BadFormattedResponse", message: `Response couldn't be parsed as JSON (${req.responseText}):\n${e.toString()}` });
                listenersDict["fatal"].forEach((hook) => hook(e, name, args));
            }
        };

        req.send(JSON.stringify(body));
    });
}
